/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ActivatePosTerminalCommand {
  /** @format uuid */
  id?: string;
}

export interface ActivateVendorCommand {
  isActive?: boolean;
}

export interface AddStaffCommand {
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  roleIds?: string[] | null;
  vendorId?: string | null;
}

export interface AddUserSubscriptionCodeCommand {
  /** @format int32 */
  code?: number | null;
  userId?: string | null;
}

export interface AddressQueryResponse {
  id?: string | null;
  title?: string | null;
  detail?: string | null;
  polygonName?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  isActive?: boolean | null;
  /** @format date-time */
  createdAt?: string;
}

export interface AddressQueryResponseListResponseMessage {
  data?: AddressQueryResponse[] | null;
  status?: string | null;
}

export interface AddressQueryResponseResponseMessage {
  data?: AddressQueryResponse;
  status?: string | null;
}

export interface AdminLoginCommand {
  phoneNumber?: string | null;
  password?: string | null;
}

export interface ApiError {
  data?: Error;
}

export interface AvailabilityTimeQueryResponse {
  id?: string | null;
  dayOfWeek?: string | null;
  startTime?: string | null;
  endTime?: string | null;
}

export interface AvailableContractResponse {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  endDate?: string;
  /** @format int32 */
  duration?: number;
  /** @format int32 */
  tip?: number;
  /** @format int32 */
  tax?: number;
  /** @format int32 */
  commission?: number;
  commissionType?: CommissionType;
  /** @format date-time */
  createdAt?: string;
}

export interface AvailableContractResponseResponseMessage {
  data?: AvailableContractResponse;
  status?: string | null;
}

export interface AvailableSegmentQueryResponse {
  /** @format uuid */
  id?: string;
  segmentType?: SegmentType;
  title?: string | null;
  description?: string | null;
  canSendGroupMessageManual?: boolean;
  property?: Property[] | null;
}

export interface AvailableSegmentQueryResponseListResponseMessage {
  data?: AvailableSegmentQueryResponse[] | null;
  status?: string | null;
}

export interface BankCreatedEvent {
  /** @format int32 */
  id?: number;
  name?: string | null;
  isActive?: boolean;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface BankCreatedEventResponseMessage {
  data?: BankCreatedEvent;
  status?: string | null;
}

export interface BankQueryResponse {
  /** @format int32 */
  id?: number;
  name?: string | null;
  isActive?: boolean;
}

export interface BankQueryResponsePaginatedList {
  items?: BankQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface BankQueryResponsePaginatedListResponseMessage {
  data?: BankQueryResponsePaginatedList;
  status?: string | null;
}

export interface BankQueryResponseResponseMessage {
  data?: BankQueryResponse;
  status?: string | null;
}

export interface ChangeDiscountCodeActivityStatusCommand {
  /** @format uuid */
  id?: string;
  active?: boolean;
  /** @format uuid */
  vendorId?: string;
}

export interface ChangeVendorBankActivityStatusCommand {
  /** @format int32 */
  id?: number;
  isActive?: boolean;
}

export enum CommissionType {
  PERCENTAGE = 'PERCENTAGE',
  FIX = 'FIX',
}

export interface CreateAddressCommand {
  title?: string | null;
  detail?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface CreateAddressResponse {
  id?: string | null;
  title?: string | null;
  detail?: string | null;
  /** @format double */
  longitude?: number | null;
  /** @format double */
  latitude?: number | null;
}

export interface CreateAddressResponseResponseMessage {
  data?: CreateAddressResponse;
  status?: string | null;
}

export interface CreateAvailabilityTimeCommand {
  dayOfWeek?: WeekDay;
  startTime?: string | null;
  endTime?: string | null;
}

export interface CreateBankCommand {
  name?: string | null;
  isActive?: boolean;
}

export interface CreateCustomerCommand {
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  address?: string | null;
  secondPhoneNumber?: string | null;
  polygonName?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface CreateDefaultDescriptionCommand {
  text?: string | null;
}

export interface CreateDeliveryZoneCommand {
  /** @format int32 */
  price?: number;
  fleetMethod?: DeliveryProvider;
  polygonName?: string | null;
}

export interface CreateDiscountCodeCommand {
  code?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format date-time */
  expiration?: string | null;
  type?: DiscountCodeType;
  /** @format int32 */
  value?: number;
  /** @format int32 */
  cap?: number | null;
  freeItems?: string[] | null;
  users?: string[] | null;
}

export interface CreateFeedbackCommand {
  /** @format uuid */
  orderId?: string;
  /** @format int32 */
  satisfaction?: number;
  description?: string | null;
  viewpointsId?: number[] | null;
}

export interface CreateOfflineAddressCommand {
  /** @format uuid */
  userId?: string;
  detail?: string | null;
  polygonName?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface CreatePosTerminalCommand {
  title?: string | null;
  bank?: TerminalBanksProvider;
  protocol?: string | null;
  port?: string | null;
  ip?: string | null;
  acceptorId?: string | null;
  terminalId?: string | null;
  posId?: string | null;
  /** @format int32 */
  timeOut?: number;
}

export interface CreateRolePermissionCommand {
  title?: string | null;
  permissionIds?: string[] | null;
}

export interface CreateSegmentationCommand {
  /** @format uuid */
  availableSegmentId?: string;
  propertyValue?: PropertyValue[] | null;
}

export interface CreateSmsPackageTransactionCommand {
  /** @format uuid */
  packageId?: string;
  provider?: PaymentServiceType;
  submitUrl?: string | null;
}

export interface CreateSubscriptionCommand {
  /** @format uuid */
  contractId?: string;
  /** @format uuid */
  packageId?: string;
  submitUrl?: string | null;
  description?: string | null;
  propertyValue?: PropertyValue[] | null;
}

export interface CreateVendorBankCommand {
  /** @format int32 */
  bankId?: number;
  displayName?: string | null;
  isActive?: boolean;
}

export interface CreatedRefreshTokenEvent {
  token?: string | null;
  refreshToken?: string | null;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface CreatedRefreshTokenEventResponseMessage {
  data?: CreatedRefreshTokenEvent;
  status?: string | null;
}

export enum Currency {
  TOMAN = 'TOMAN',
  RIAL = 'RIAL',
}

export interface CustomerCreatedEvent {
  /** @format uuid */
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  addressId?: string | null;
  detail?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
  polygonName?: string | null;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface CustomerCreatedEventResponseMessage {
  data?: CustomerCreatedEvent;
  status?: string | null;
}

export interface CustomerReportListResponse {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  /** @format int64 */
  totalOrder?: number;
  /** @format int64 */
  totalOrderPrice?: number;
}

export interface CustomerReportListResponsePaginatedList {
  items?: CustomerReportListResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface CustomerReportListResponsePaginatedListResponseMessage {
  data?: CustomerReportListResponsePaginatedList;
  status?: string | null;
}

export interface CustomerSearchQueryResponse {
  id?: string | null;
  searchId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  addressId?: string | null;
  address?: string | null;
  /** @format int32 */
  subscriptionCode?: number | null;
}

export interface CustomerSearchQueryResponseListResponseMessage {
  data?: CustomerSearchQueryResponse[] | null;
  status?: string | null;
}

export interface DeActivatePosTerminalCommand {
  /** @format uuid */
  id?: string;
}

export interface DefaultDescriptionQueryResponse {
  /** @format int32 */
  id?: number;
  text?: string | null;
  isActive?: boolean | null;
}

export interface DefaultDescriptionQueryResponseListResponseMessage {
  data?: DefaultDescriptionQueryResponse[] | null;
  status?: string | null;
}

export interface DefaultDescriptionQueryResponsePaginatedList {
  items?: DefaultDescriptionQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DefaultDescriptionQueryResponsePaginatedListResponseMessage {
  data?: DefaultDescriptionQueryResponsePaginatedList;
  status?: string | null;
}

export interface DefaultDescriptionQueryResponseResponseMessage {
  data?: DefaultDescriptionQueryResponse;
  status?: string | null;
}

export interface DeletePosTerminalCommand {
  /** @format uuid */
  id?: string;
}

export interface DeleteSegmentationCommand {
  /** @format uuid */
  id?: string;
}

export interface DeleteStaffCommand {
  /** @format uuid */
  id?: string;
  vendorId?: string | null;
}

export interface DeleteUserSubscriptionCodeCommand {
  userId?: string | null;
}

export enum DeliveryProvider {
  MIARE = 'MIARE',
  SNAPP_BOX = 'SNAPP_BOX',
  OWN_FLEET = 'OWN_FLEET',
  ZFEXPRESS = 'ZFEXPRESS',
  BORDAR = 'BORDAR',
}

export enum DeliveryProviderName {
  MIARE = 'MIARE',
  SNAPPBOX = 'SNAPPBOX',
  EXPRESSPLUS = 'EXPRESSPLUS',
  BORDAR = 'BORDAR',
}

export enum DeliveryType {
  DELIVER = 'DELIVER',
  PICKUP = 'PICKUP',
  SERVE = 'SERVE',
  ZFEXPRESS = 'ZFEXPRESS',
}

export interface DeliveryZoneQueryResponse {
  id?: string | null;
  /** @format int32 */
  price?: number;
  fleetMethod?: string | null;
  polygonName?: string | null;
}

export interface DeliveryZoneQueryResponseListResponseMessage {
  data?: DeliveryZoneQueryResponse[] | null;
  status?: string | null;
}

export interface DeliveryZoneQueryResponseResponseMessage {
  data?: DeliveryZoneQueryResponse;
  status?: string | null;
}

export interface DiscountCodeAvaliableQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  type?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format date-time */
  expiration?: string | null;
  /** @format int32 */
  value?: number | null;
  /** @format int32 */
  cap?: number | null;
  vendorId?: string | null;
  code?: string | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format int32 */
  vendorDeal?: number;
  /** @format int32 */
  userCount?: number;
}

export interface DiscountCodeAvaliableQueryResponsePaginatedList {
  items?: DiscountCodeAvaliableQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiscountCodeAvaliableQueryResponsePaginatedListResponseMessage {
  data?: DiscountCodeAvaliableQueryResponsePaginatedList;
  status?: string | null;
}

export interface DiscountCodeListQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format int32 */
  usageCount?: number | null;
  active?: boolean | null;
  code?: string | null;
  vendorName?: string | null;
}

export interface DiscountCodeListQueryResponsePaginatedList {
  items?: DiscountCodeListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiscountCodeListQueryResponsePaginatedListResponseMessage {
  data?: DiscountCodeListQueryResponsePaginatedList;
  status?: string | null;
}

export interface DiscountCodeMenuItemQueryResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  servePackagingCost?: number;
  withTax?: boolean;
}

export interface DiscountCodeOrderQueryResponse {
  id?: string | null;
  orderCode?: string | null;
  /** @format int32 */
  discount?: number | null;
  state?: string | null;
}

export interface DiscountCodeQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  type?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format date-time */
  expiration?: string | null;
  /** @format int32 */
  value?: number | null;
  /** @format int32 */
  cap?: number | null;
  vendorId?: string | null;
  code?: string | null;
  active?: boolean | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format int32 */
  vendorDeal?: number;
  /** @format int32 */
  userCount?: number;
  menuItems?: DiscountCodeMenuItemQueryResponse[] | null;
  users?: DiscountCodeUserQueryResponse[] | null;
  orders?: DiscountCodeOrderQueryResponse[] | null;
}

export interface DiscountCodeQueryResponsePaginatedList {
  items?: DiscountCodeQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiscountCodeQueryResponsePaginatedListResponseMessage {
  data?: DiscountCodeQueryResponsePaginatedList;
  status?: string | null;
}

export interface DiscountCodeQueryResponseResponseMessage {
  data?: DiscountCodeQueryResponse;
  status?: string | null;
}

export enum DiscountCodeType {
  FREEITEM = 'FREEITEM',
  PERCENTAGE = 'PERCENTAGE',
  FREESHIPPING = 'FREESHIPPING',
  MONEY = 'MONEY',
}

export interface DiscountCodeUserQueryResponse {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
}

export interface Error {
  message?: string | null;
  errors?: Record<string, string[]>;
}

export interface ExcelResponse {
  link?: string | null;
}

export interface ExcelResponseResponseMessage {
  data?: ExcelResponse;
  status?: string | null;
}

export interface FeatureQueryResponse {
  id?: string | null;
  name?: string | null;
  columnName?: string | null;
}

export interface FeatureQueryResponseListResponseMessage {
  data?: FeatureQueryResponse[] | null;
  status?: string | null;
}

export interface GetVendorByDomainResponse {
  hasActivePOS?: boolean;
  id?: string | null;
  name?: string | null;
  subDomain?: string | null;
  logo?: string | null;
  cover?: string | null;
  customDomain?: string | null;
  address?: string | null;
  phoneNumber?: string | null;
  iban?: string | null;
  description?: string | null;
  /** @format int64 */
  deliveryCost?: number;
  /** @format int64 */
  packagingCost?: number;
  /** @format int64 */
  deliveryShare?: number;
  /** @format int64 */
  deliveryDistance?: number;
  /** @format int64 */
  minimumBasket?: number;
  /** @format int64 */
  servePackagingCost?: number;
  /** @format int64 */
  serviceChargeCost?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  /** @format int32 */
  tax?: number;
  autoCall?: boolean;
  defaultTip?: boolean | null;
  isActive?: boolean | null;
  autoAccept?: boolean;
  hasSnappFood?: boolean;
  requiredCustomerNumber?: boolean;
  showPaymentModal?: boolean;
  deliverType?: string[] | null;
  hasCallerId?: boolean;
  isPostPaid?: boolean;
  isQuickOrder?: boolean;
  hasOfflineAccess?: boolean;
  hasRatingMessage?: boolean;
  snappClubEnabled?: boolean;
  directDebitEnabled?: boolean;
  currency?: Currency;
  printAllItemsOnFactor?: boolean | null;
  instagramUserName?: string | null;
}

export interface GetVendorByDomainResponseResponseMessage {
  data?: GetVendorByDomainResponse;
  status?: string | null;
}

export interface LandingQueryResponse {
  id?: string | null;
  banner?: string | null;
  vendors?: Vendors[] | null;
}

export interface LandingQueryResponseResponseMessage {
  data?: LandingQueryResponse;
  status?: string | null;
}

export interface LoginCommand {
  phoneNumber?: string | null;
}

export interface LoginResponse {
  /** @format uuid */
  id?: string;
  isRegistered?: boolean;
  phoneNumber?: string | null;
}

export interface LoginResponseResponseMessage {
  data?: LoginResponse;
  status?: string | null;
}

export interface MenuItemQueryResponse {
  id?: string | null;
  title?: string | null;
}

export interface MyPermissionQueryResponse {
  action?: string | null;
  features?: string | null;
}

export interface MyPermissionQueryResponseListResponseMessage {
  data?: MyPermissionQueryResponse[] | null;
  status?: string | null;
}

export interface Options {
  label?: string | null;
  value?: string | null;
}

export interface OrderInfoQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  finalPrice?: number | null;
  orderType?: OrderType;
  menuItems?: MenuItemQueryResponse[] | null;
}

export interface OrderInfoQueryResponseResponseMessage {
  data?: OrderInfoQueryResponse;
  status?: string | null;
}

export enum OrderType {
  WEBSITE = 'WEBSITE',
  QR = 'QR',
  SALON = 'SALON',
  SNAPPFOOD = 'SNAPPFOOD',
  KIOSK = 'KIOSK',
}

export interface PackagePriceQueryResponse {
  /** @format int64 */
  price?: number;
  /** @format int32 */
  tax?: number;
}

export interface PackagePriceQueryResponseResponseMessage {
  data?: PackagePriceQueryResponse;
  status?: string | null;
}

export interface PackageQueryResponse {
  /** @format uuid */
  id?: string;
  featureId?: string | null;
  name?: string | null;
  /** @format int32 */
  duration?: number;
  /** @format int64 */
  price?: number;
  description?: string | null;
  /** @format int32 */
  demo?: number;
  /** @format int32 */
  installation?: number;
  /** @format int32 */
  discount?: number;
  property?: Property[] | null;
}

export interface PackageQueryResponseListResponseMessage {
  data?: PackageQueryResponse[] | null;
  status?: string | null;
}

export interface PackageQueryResponseResponseMessage {
  data?: PackageQueryResponse;
  status?: string | null;
}

export interface PaymentResponse {
  link?: string | null;
}

export interface PaymentResponseResponseMessage {
  data?: PaymentResponse;
  status?: string | null;
}

export enum PaymentServiceType {
  ZARIN_PAL = 'ZARIN_PAL',
  VANDAR = 'VANDAR',
  JIBIT = 'JIBIT',
  SNAPP_PAY_DIRECTDEBIT = 'SNAPP_PAY_DIRECTDEBIT',
  SNAPP_PAY_POSTPAID = 'SNAPP_PAY_POSTPAID',
  SNAPP_FOOD_WALLET = 'SNAPP_FOOD_WALLET',
  POS = 'POS',
  NONE = 'NONE',
  KIOSK = 'KIOSK',
}

export interface PermissionQueryResponse {
  featureColumnName?: string | null;
  permissions?: PermissionResponse[] | null;
}

export interface PermissionQueryResponseListResponseMessage {
  data?: PermissionQueryResponse[] | null;
  status?: string | null;
}

export interface PermissionResponse {
  id?: string | null;
  action?: string | null;
  commonName?: string | null;
}

export interface PosTerminalViewModel {
  /** @format uuid */
  id?: string;
  title?: string | null;
  bank?: TerminalBanksProvider;
  protocol?: string | null;
  ip?: string | null;
  port?: string | null;
  acceptorId?: string | null;
  terminalId?: string | null;
  posId?: string | null;
  /** @format int32 */
  timeOut?: number;
  active?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface PosTerminalViewModelListResponseMessage {
  data?: PosTerminalViewModel[] | null;
  status?: string | null;
}

export interface PosTerminalViewModelResponseMessage {
  data?: PosTerminalViewModel;
  status?: string | null;
}

export interface ProfileQueryResponse {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  image?: string | null;
  email?: string | null;
  roles?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface ProfileQueryResponseResponseMessage {
  data?: ProfileQueryResponse;
  status?: string | null;
}

export interface PropValue {
  prop?: string | null;
  value?: string | null;
}

export interface Property {
  prop?: string | null;
  type?: PropertyType;
  title?: string | null;
  description?: string | null;
  isRequired?: boolean;
  defaultValue?: string | null;
  options?: Options[] | null;
}

export enum PropertyType {
  INT = 'INT',
  TEXT = 'TEXT',
  TEXT_AREA = 'TEXT_AREA',
  MULTI = 'MULTI',
  SELECT = 'SELECT',
  RADIO = 'RADIO',
  BOOLEAN = 'BOOLEAN',
  DISCOUNT_CODE = 'DISCOUNT_CODE',
}

export interface PropertyValue {
  prop?: string | null;
  value?: string | null;
}

export interface RefreshTokenCommand {
  refreshToken?: string | null;
}

export interface ReportSegmentationListQueryResponse {
  /** @format date-time */
  sendDate?: string;
  /** @format int32 */
  sentCount?: number;
  /** @format int32 */
  sentSuccessCount?: number;
}

export interface ReportSegmentationListQueryResponsePaginatedList {
  items?: ReportSegmentationListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface ReportSegmentationListQueryResponsePaginatedListResponseMessage {
  data?: ReportSegmentationListQueryResponsePaginatedList;
  status?: string | null;
}

export interface RolePermissionQueryResponse {
  id?: string | null;
  name?: string | null;
  permissions?: string[] | null;
}

export interface RolePermissionQueryResponseResponseMessage {
  data?: RolePermissionQueryResponse;
  status?: string | null;
}

export interface RoleQueryResponse {
  id?: string | null;
  name?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface RoleQueryResponseListResponseMessage {
  data?: RoleQueryResponse[] | null;
  status?: string | null;
}

export enum SegmentType {
  NEW_CUSTOMER = 'NEW_CUSTOMER',
  RECENT_CUSTOMER = 'RECENT_CUSTOMER',
  ORDER_TYPE_CUSTOMER = 'ORDER_TYPE_CUSTOMER',
  ALL_CUSTOMER = 'ALL_CUSTOMER',
  ACTIVE_CUSTOMER = 'ACTIVE_CUSTOMER',
  LOYAL_CUSTOMER = 'LOYAL_CUSTOMER',
  DISABLE_CUSTOMER = 'DISABLE_CUSTOMER',
  UNHAPPY_CUSTOMER = 'UNHAPPY_CUSTOMER',
}

export interface SegmentationsListQueryResponse {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  availableSegmentId?: string;
  vendorId?: string | null;
  isActive?: boolean;
  propertyValue?: PropValue[] | null;
}

export interface SegmentationsListQueryResponseListResponseMessage {
  data?: SegmentationsListQueryResponse[] | null;
  status?: string | null;
}

export interface SendNotificationSegmentCommand {
  /** @format uuid */
  segmentationId?: string;
}

export interface SendOtpForBikerCommand {
  phoneNumber?: string | null;
}

export interface SetPrintItemsOnFactorOptionCommand {
  printAllItemsOnFactor?: boolean;
}

export interface SiteDiscountCodeQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  type?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format date-time */
  expiration?: string | null;
  /** @format int32 */
  value?: number | null;
  /** @format int32 */
  cap?: number | null;
  vendorId?: string | null;
  code?: string | null;
  active?: boolean | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format int32 */
  vendorDeal?: number;
  /** @format int32 */
  userCount?: number;
  freeItems?: DiscountCodeMenuItemQueryResponse[] | null;
}

export interface SiteDiscountCodeQueryResponseResponseMessage {
  data?: SiteDiscountCodeQueryResponse;
  status?: string | null;
}

export interface SmsPackageQueryResponse {
  /** @format uuid */
  id?: string;
  name?: string | null;
  /** @format int32 */
  count?: number;
  /** @format double */
  amount?: number;
}

export interface SmsPackageQueryResponseListResponseMessage {
  data?: SmsPackageQueryResponse[] | null;
  status?: string | null;
}

export interface SmsPackageTransactionDetailsResponse {
  /** @format uuid */
  id?: string | null;
  /** @format uuid */
  vendorId?: string | null;
  /** @format uuid */
  packageId?: string | null;
  /** @format double */
  amount?: number | null;
  provider?: PaymentServiceType;
  submitUrl?: string | null;
  bankTransactionId?: string | null;
  bankToken?: string | null;
  paymentStatus?: TransactionStatus;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface SmsPackageTransactionDetailsResponseResponseMessage {
  data?: SmsPackageTransactionDetailsResponse;
  status?: string | null;
}

export interface SmsPackageTransactionQueryResponse {
  /** @format uuid */
  id?: string;
  /** @format double */
  amount?: number;
  provider?: PaymentServiceType;
  submitUrl?: string | null;
  bankTransactionId?: string | null;
  bankToken?: string | null;
  paymentStatus?: TransactionStatus;
  /** @format date-time */
  createdAt?: string;
  smsPackageName?: string | null;
}

export interface SmsPackageTransactionQueryResponsePaginatedList {
  items?: SmsPackageTransactionQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface SmsPackageTransactionQueryResponsePaginatedListResponseMessage {
  data?: SmsPackageTransactionQueryResponsePaginatedList;
  status?: string | null;
}

export interface SmsPackageTransactionResponse {
  link?: string | null;
}

export interface SmsPackageTransactionResponseResponseMessage {
  data?: SmsPackageTransactionResponse;
  status?: string | null;
}

export interface StringResponseMessage {
  data?: string | null;
  status?: string | null;
}

export interface SubscriptionCreatedEvent {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  usageId?: string;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface SubscriptionCreatedEventResponseMessage {
  data?: SubscriptionCreatedEvent;
  status?: string | null;
}

export enum SubscriptionType {
  CONTRACT = 'CONTRACT',
  SERVICE = 'SERVICE',
}

export enum TerminalBanksProvider {
  MELLAT = 'MELLAT',
  MELLI = 'MELLI',
  TEJARAT = 'TEJARAT',
  SAMAN = 'SAMAN',
  ASANPARDAKHT = 'ASANPARDAKHT',
  PARSIAN_DLL = 'PARSIAN_DLL',
  PARSIAN_JSON = 'PARSIAN_JSON',
  PASARGAD = 'PASARGAD',
}

export interface TerminalBanksProviderArrayResponseMessage {
  data?: TerminalBanksProvider[] | null;
  status?: string | null;
}

export enum TransactionStatus {
  INIT = 'INIT',
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  DONE = 'DONE',
}

export enum TransactionType {
  TOPUP = 'TOPUP',
  REFUND = 'REFUND',
}

export interface UpdateActivationDescriptionCommand {
  /** @format int32 */
  id?: number;
  isActive?: boolean;
}

export interface UpdateAddressCommand {
  id?: string | null;
  title?: string | null;
  detail?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface UpdateBankCommand {
  /** @format int32 */
  id?: number;
  name?: string | null;
  isActive?: boolean;
}

export interface UpdateDeliveryZoneCommand {
  id?: string | null;
  /** @format int32 */
  price?: number;
  fleetMethod?: DeliveryProvider;
  polygonName?: string | null;
}

export interface UpdateDiscountCodeCommand {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  vendorId?: string;
  code?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format date-time */
  expiration?: string | null;
  type?: DiscountCodeType;
  /** @format int32 */
  cap?: number | null;
  /** @format int32 */
  value?: number | null;
  active?: boolean;
  /** @format int32 */
  vendorDeal?: number;
}

export interface UpdateLatLongOfflineAddressCommand {
  id?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface UpdateMyInfoCommand {
  name?: string | null;
  subDomain?: string | null;
  logo?: string | null;
  cover?: string | null;
  customDomain?: string | null;
  address?: string | null;
  phoneNumber?: string | null;
  iban?: string | null;
  description?: string | null;
  /** @format int32 */
  deliveryCost?: number;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  deliveryShare?: number;
  /** @format int32 */
  deliveryDistance?: number;
  /** @format int32 */
  minimumBasket?: number;
  /** @format int32 */
  servePackagingCost?: number;
  /** @format int32 */
  serviceChargeCost?: number;
  /** @format int32 */
  tax?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  autoAccept?: boolean;
  requiredCustomerNumber?: boolean;
  deliverType?: DeliveryType[] | null;
  hasCallerId?: boolean;
  printAllItemsOnFactor?: boolean;
  instagramUserName?: string | null;
  displayInstagramUserName?: boolean;
}

export interface UpdateOfflineAddressCommand {
  id?: string | null;
  detail?: string | null;
  polygonName?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface UpdatePosTerminalCommand {
  /** @format uuid */
  id?: string;
  title?: string | null;
  bank?: TerminalBanksProvider;
  protocol?: string | null;
  port?: string | null;
  ip?: string | null;
  acceptorId?: string | null;
  terminalId?: string | null;
  posId?: string | null;
  /** @format int32 */
  timeOut?: number;
}

export interface UpdateProfileCommand {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export interface UpdateRolePermissionCommand {
  /** @format uuid */
  roleId?: string;
  title?: string | null;
  permissionIds?: string[] | null;
}

export interface UpdateSegmentationCommand {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  availableSegmentId?: string;
  isActive?: boolean;
  propertyValue?: PropertyValue[] | null;
}

export interface UpdateUserStaffRoleCommand {
  userId?: string | null;
  vendorId?: string | null;
  roleIds?: string[] | null;
}

export interface UpdateUserSubscriptionCodeCommand {
  userId?: string | null;
  /** @format int32 */
  code?: number | null;
}

export interface UsageListQueryResponse {
  /** @format uuid */
  id?: string;
  number?: string | null;
  /** @format int32 */
  duration?: number;
  /** @format int32 */
  percentTax?: number;
  /** @format int32 */
  tax?: number;
  /** @format int64 */
  price?: number;
  /** @format int64 */
  finalPrice?: number;
  description?: string | null;
  /** @format date-time */
  startDate?: string;
  /** @format date-time */
  expireOn?: string;
  /** @format uuid */
  subscriptionId?: string;
  paymentStatus?: UsagePaymentStatus;
  /** @format int32 */
  discountPercentage?: number;
  type?: SubscriptionType;
  featureName?: string | null;
  /** @format int32 */
  demo?: number;
  /** @format int32 */
  installation?: number;
}

export interface UsageListQueryResponsePaginatedList {
  items?: UsageListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface UsageListQueryResponsePaginatedListResponseMessage {
  data?: UsageListQueryResponsePaginatedList;
  status?: string | null;
}

export enum UsagePaymentStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  FAILED = 'FAILED',
}

export interface UsageStatusQueryResponse {
  packageName?: string | null;
  /** @format date-time */
  purchaseDate?: string | null;
  /** @format int32 */
  duration?: number;
  /** @format date-time */
  expireOn?: string;
  /** @format uuid */
  id?: string;
}

export interface UsageStatusQueryResponseListResponseMessage {
  data?: UsageStatusQueryResponse[] | null;
  status?: string | null;
}

export interface UsageTransactionQueryResponse {
  /** @format uuid */
  id?: string;
  bankTransactionId?: string | null;
  /** @format double */
  amount?: number;
  status?: TransactionStatus;
  type?: TransactionType;
  provider?: PaymentServiceType;
  /** @format date-time */
  createdAt?: string;
}

export interface UsageTransactionQueryResponseResponseMessage {
  data?: UsageTransactionQueryResponse;
  status?: string | null;
}

export interface UserCreatedEvent {
  /** @format uuid */
  id?: string;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  image?: string | null;
  phoneNumberConfirmed?: boolean;
  emailConfirmed?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  roles?: string[] | null;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface UserCreatedEventResponseMessage {
  data?: UserCreatedEvent;
  status?: string | null;
}

export interface UserListQueryResponse {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  roles?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  vendorId?: string | null;
  vendorSubdomain?: string | null;
}

export interface UserListQueryResponsePaginatedList {
  items?: UserListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface UserListQueryResponsePaginatedListResponseMessage {
  data?: UserListQueryResponsePaginatedList;
  status?: string | null;
}

export interface UserPermissionQueryResponse {
  action?: string | null;
  featureName?: string | null;
}

export interface UserQueryResponse {
  id?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  phoneNumberConfirmed?: boolean;
  roles?: string[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
  image?: string | null;
  email?: string | null;
}

export interface UserQueryResponseResponseMessage {
  data?: UserQueryResponse;
  status?: string | null;
}

export interface UserSegmentationListQueryResponse {
  fullName?: string | null;
  mobile?: string | null;
}

export interface UserSegmentationListQueryResponsePaginatedList {
  items?: UserSegmentationListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface UserSegmentationListQueryResponsePaginatedListResponseMessage {
  data?: UserSegmentationListQueryResponsePaginatedList;
  status?: string | null;
}

export enum UserType {
  CUSTOMER = 'CUSTOMER',
  STAFF = 'STAFF',
}

export interface VendorAvailabilityTimeQueryResponse {
  isVendorOpen?: boolean;
  isVendorActive?: boolean;
  availabilityTimes?: AvailabilityTimeQueryResponse[] | null;
}

export interface VendorAvailabilityTimeQueryResponseResponseMessage {
  data?: VendorAvailabilityTimeQueryResponse;
  status?: string | null;
}

export interface VendorBankCreatedEvent {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  bankId?: number;
  /** @format uuid */
  vendorId?: string;
  displayName?: string | null;
  isActive?: boolean;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface VendorBankQueryResponse {
  /** @format int32 */
  id?: number;
  bankName?: string | null;
  displayName?: string | null;
  isActive?: boolean;
  /** @format date-time */
  createdAt?: string;
  vendorId?: string | null;
}

export interface VendorBankQueryResponsePaginatedList {
  items?: VendorBankQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface VendorBankQueryResponsePaginatedListResponseMessage {
  data?: VendorBankQueryResponsePaginatedList;
  status?: string | null;
}

export interface VendorBrandQueryResponse {
  id?: string | null;
  name?: string | null;
}

export interface VendorBrandQueryResponseListResponseMessage {
  data?: VendorBrandQueryResponse[] | null;
  status?: string | null;
}

export interface VendorQueryResponse {
  id?: string | null;
  name?: string | null;
  subDomain?: string | null;
  logo?: string | null;
  cover?: string | null;
  customDomain?: string | null;
  address?: string | null;
  phoneNumber?: string | null;
  iban?: string | null;
  description?: string | null;
  /** @format int64 */
  deliveryCost?: number;
  /** @format int64 */
  packagingCost?: number;
  /** @format int64 */
  deliveryShare?: number;
  /** @format int64 */
  deliveryDistance?: number;
  /** @format int64 */
  minimumBasket?: number;
  /** @format int64 */
  servePackagingCost?: number;
  /** @format int64 */
  serviceChargeCost?: number;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  /** @format int32 */
  tax?: number;
  autoCall?: boolean;
  defaultTip?: boolean | null;
  isActive?: boolean | null;
  autoAccept?: boolean;
  hasSnappFood?: boolean;
  requiredCustomerNumber?: boolean;
  showPaymentModal?: boolean;
  deliverType?: string[] | null;
  salonDeliverType?: string[] | null;
  hasCallerId?: boolean;
  isPostPaid?: boolean;
  isQuickOrder?: boolean;
  hasOfflineAccess?: boolean;
  hasRatingMessage?: boolean;
  snappClubEnabled?: boolean;
  directDebitEnabled?: boolean;
  currency?: Currency;
  deliveryProviders?: DeliveryProviderName[] | null;
  printAllItemsOnFactor?: boolean | null;
  instagramUserName?: string | null;
  displayInstagramUserName?: boolean;
  segmentationEnabled?: boolean;
  hasActivePOS?: boolean;
}

export interface VendorQueryResponseResponseMessage {
  data?: VendorQueryResponse;
  status?: string | null;
}

export interface VendorSmsPackageCreditResponse {
  /** @format int32 */
  remaining?: number | null;
}

export interface VendorSmsPackageCreditResponseResponseMessage {
  data?: VendorSmsPackageCreditResponse;
  status?: string | null;
}

export interface Vendors {
  id?: string | null;
  name?: string | null;
  logo?: string | null;
  customDomain?: string | null;
  subDomain?: string | null;
}

export interface VerifyBikerOtpCommand {
  otp?: string | null;
  /** @format uuid */
  userId?: string;
}

export interface VerifyOtpCommand {
  /** @format uuid */
  userId?: string;
  otp?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

export interface VerifyOtpResponse {
  token?: string | null;
  refreshToken?: string | null;
}

export interface VerifyOtpResponseResponseMessage {
  data?: VerifyOtpResponse;
  status?: string | null;
}

export interface ViewpointListQueryResponse {
  /** @format int64 */
  id?: number;
  content?: string | null;
  type?: ViewpointType;
}

export interface ViewpointListQueryResponseListResponseMessage {
  data?: ViewpointListQueryResponse[] | null;
  status?: string | null;
}

export enum ViewpointType {
  PROS = 'PROS',
  CONS = 'CONS',
}

export enum WeekDay {
  MON = 'MON',
  TUE = 'TUE',
  WED = 'WED',
  THU = 'THU',
  FRI = 'FRI',
  SAT = 'SAT',
  SUN = 'SUN',
}

export interface ActiveDiningTableCategoryRequest {
  id?: string | null;
  isActive?: boolean;
}

export interface AddressDto {
  id?: string | null;
  title?: string | null;
  details?: string | null;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface AllBikerQueryResponse {
  /** @format uuid */
  userId?: string;
  name?: string | null;
  status?: string | null;
}

export interface AllBikerQueryResponseListResponseMessage {
  data?: AllBikerQueryResponse[] | null;
  status?: string | null;
}

export interface ApprovePOSPaymentCommand {
  /** @format uuid */
  transactionId?: string;
  /** @format int32 */
  errorCode?: number;
  errorMessage?: string | null;
  refrenceNumber?: string | null;
  trackingNumber?: string | null;
  cardNumber?: string | null;
  amount?: string | null;
}

export interface Area {
  id?: string | null;
  name?: string | null;
}

export interface AssignedOrderToBikersResponse {
  /** @format int64 */
  sumOfOrders?: number;
  /** @format int64 */
  sumOfFinalPrice?: number;
  /** @format int64 */
  sumOfDeliverCost?: number;
}

export interface AssignedOrderToBikersResponseResponseMessage {
  data?: AssignedOrderToBikersResponse;
  status?: string | null;
}

export interface BankConfigurationQueryResponse {
  bankTypes?: BankType[] | null;
  preSelectedProvider?: PaymentServiceType;
}

export interface BankConfigurationQueryResponseResponseMessage {
  data?: BankConfigurationQueryResponse;
  status?: string | null;
}

export interface BankType {
  type?: PaymentServiceType;
  isActive?: boolean;
}

export interface BatchAssignOrderToBikerCommand {
  bikerDtos?: BatchAssignOrderToBikerDto[] | null;
}

export interface BatchAssignOrderToBikerDto {
  /** @format uuid */
  userId?: string | null;
  /** @format uuid */
  orderId?: string;
}

export interface BikerAssignedOrderQueryResponse {
  historyId?: string | null;
  orderId?: string | null;
  customerName?: string | null;
  billNumber?: string | null;
  /** @format int32 */
  factorNumber?: number | null;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format date-time */
  createdAt?: string;
}

export interface BikerQueryResponse {
  /** @format uuid */
  userId?: string;
  name?: string | null;
}

export interface BikerQueryResponseListResponseMessage {
  data?: BikerQueryResponse[] | null;
  status?: string | null;
}

export interface BikerQueryResponsePaginatedList {
  items?: BikerQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface BikerQueryResponsePaginatedListResponseMessage {
  data?: BikerQueryResponsePaginatedList;
  status?: string | null;
}

export interface BikerReportQueryPerOrderResponse {
  userId?: string | null;
  /** @format int64 */
  finalPrice?: number;
  /** @format int64 */
  deliveryCost?: number;
  paymentMethod?: PaymentMethod;
  billNumber?: string | null;
  bikerName?: string | null;
  phoneNumber?: string | null;
  orderId?: string | null;
  address?: string | null;
  deliveryState?: string | null;
  orderState?: OrderState;
  /** @format date-time */
  createdAt?: string;
  /** @format double */
  deliveryDurationInMinutes?: number | null;
}

export interface BikerReportQueryPerOrderResponsePaginatedList {
  items?: BikerReportQueryPerOrderResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface BikerReportRespose {
  paginatedResult?: BikerReportQueryPerOrderResponsePaginatedList;
  reportSummary?: AssignedOrderToBikersResponse;
}

export interface BikerReportResposeResponseMessage {
  data?: BikerReportRespose;
  status?: string | null;
}

export interface BikersAssignedOrderQueryResponse {
  bikerId?: string | null;
  fullName?: string | null;
  orders?: BikerAssignedOrderQueryResponse[] | null;
}

export interface BikersAssignedOrderQueryResponseListResponseMessage {
  data?: BikersAssignedOrderQueryResponse[] | null;
  status?: string | null;
}

export interface CancelDeliveryCommand {
  tripId?: string | null;
  reason?: string | null;
}

export interface CancelOrderReportQueryResponse {
  /** @format int64 */
  sumOfCancelledOrders?: number;
  /** @format int64 */
  totalCancelledOrders?: number;
}

export interface CancelOrderReportQueryResponseResponseMessage {
  data?: CancelOrderReportQueryResponse;
  status?: string | null;
}

export interface CancelTripEvent {
  succeeded?: boolean;
  id?: string | null;
  errors?: string[] | null;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface CancelTripEventResponseMessage {
  data?: CancelTripEvent;
  status?: string | null;
}

export interface ChangeDeliveryHistoriesToDeliveredCommand {
  dto?: DeliverOrderByBikerDto[] | null;
}

export interface ChangeDeliveryHistoryStateCommand {
  /** @format uuid */
  bikerId?: string;
  /** @format uuid */
  orderId?: string;
  state?: DeliveryState;
}

export interface ChangeOrderStateCommand {
  state?: OrderState;
  /** @format uuid */
  orderId?: string;
  /** @format int32 */
  preparationTime?: number | null;
  paymentMethod?: PaymentMethod;
  /** @format int32 */
  tip?: number | null;
  /** @format uuid */
  posTerminalId?: string | null;
}

export interface ChangeOrderTableCommand {
  /** @format uuid */
  orderId?: string;
  tableId?: string | null;
}

export interface Courier {
  image?: string | null;
  location?: Location;
  /** @format date-time */
  location_updated_at?: string | null;
  name?: string | null;
  phone_number?: string | null;
}

export interface CourseResponse {
  id?: string | null;
  trip_id?: string | null;
  old_trip_id?: string | null;
  bill_number?: string | null;
  name?: string | null;
  address?: string | null;
  phone_number?: string | null;
  tracking_url?: string | null;
  location?: Location;
  manifest_items?: ManifestItem[] | null;
  payment?: Payment;
}

export interface CreateDiningTableCategoryRequest {
  name?: string | null;
}

export interface CreateDiningTableRequest {
  tableName?: string | null;
  diningTableCategoryId?: string | null;
}

export interface CreateKioskOrderRequest {
  deliveryType?: DeliveryType;
  /** @format int32 */
  packagingCost?: number | null;
  description?: string | null;
  orderItem?: OrderItemsDto[] | null;
}

export interface CreateOrderItemRequest {
  title?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  count?: number;
  menuItemId?: string | null;
  /** @format int32 */
  packagingCost?: number;
  withTax?: boolean;
  description?: string | null;
  orderItemToppings?: CreateOrderItemToppingRequest[] | null;
}

export interface CreateOrderItemToppingRequest {
  title?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  count?: number;
  toppingId?: string | null;
}

export interface CreateOrderRequest {
  /** @format int32 */
  deliveryCost?: number;
  /** @format int32 */
  discount?: number;
  deliveryType?: string | null;
  orderType?: string | null;
  paymentMethod?: string | null;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  tax?: number;
  addressId?: string | null;
  discountCode?: string | null;
  tableId?: string | null;
  /** @format int32 */
  numberOfCustomer?: number;
  /** @format int32 */
  tip?: number;
  description?: string | null;
  customerId?: string | null;
  /** @format int32 */
  preparationTime?: number;
  /** @format int32 */
  finalPrice?: number;
  orderItem?: CreateOrderItemRequest[] | null;
}

export interface CreatePaymentLinkCommand {
  /** @format uuid */
  orderId?: string;
  mobile?: string | null;
}

export interface CreatePostPaidOrderCommand {
  paymentMethod?: PaymentMethod;
  deliveryType?: DeliveryType;
  /** @format uuid */
  posTerminalId?: string | null;
  tableId?: string | null;
  /** @format int32 */
  numberOfCustomer?: number;
  /** @format int32 */
  tip?: number;
  description?: string | null;
  customerId?: string | null;
  /** @format int32 */
  preparationTime?: number;
  addressId?: string | null;
  /** @format int32 */
  packagingCost?: number | null;
  discountCode?: string | null;
  /** @format int32 */
  discountAmount?: number | null;
  discountType?: DiscountType;
  /** @format int32 */
  serviceFee?: number;
  /** @format int32 */
  deliveryCost?: number;
  note?: string | null;
  orderItems?: OrderItemsDto[] | null;
}

export interface CreateQuickOrderRequest {
  deliveryType?: DeliveryType;
  tableId?: string | null;
  description?: string | null;
  orderItem?: OrderItemsDto[] | null;
}

export interface CreateSurveyRequest {
  isActive?: boolean;
  questionId?: string[] | null;
}

export interface CreditPaymentMethodOrdersReportResponse {
  orderId?: string | null;
  billNumber?: string | null;
  orderType?: OrderType;
  vendorId?: string | null;
  vendorName?: string | null;
  customerName?: string | null;
  /** @format int64 */
  diningTableId?: number | null;
  diningTableName?: string | null;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format date-time */
  orderDate?: string;
  deliveryType?: string | null;
  paymentMethod?: PaymentMethod;
  isPaid?: boolean;
  /** @format date-time */
  paymentDate?: string | null;
}

export interface CreditPaymentMethodOrdersReportResponsePaginatedList {
  items?: CreditPaymentMethodOrdersReportResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface CreditPaymentMethodOrdersReportResponsePaginatedListResponseMessage {
  data?: CreditPaymentMethodOrdersReportResponsePaginatedList;
  status?: string | null;
}

export interface DashboardChart {
  /** @format int64 */
  finalPrice?: number | null;
  /** @format date-time */
  date?: string;
}

export interface DashboardFeeback {
  /** @format int32 */
  like?: number | null;
  /** @format int32 */
  dislike?: number | null;
  /** @format int32 */
  count?: number | null;
}

export interface DashboardFeebackViewpoint {
  content?: string | null;
  /** @format int32 */
  count?: number;
  type?: ViewpointType;
}

export interface DashboardMenuCategory {
  /** @format int64 */
  count?: number;
  title?: string | null;
}

export interface DashboardProduct {
  /** @format int64 */
  price?: number | null;
  /** @format int64 */
  count?: number;
  title?: string | null;
}

export interface DashboardReportQueryResponse {
  /** @format int64 */
  totalFinalPrice?: number | null;
  /** @format int32 */
  totalCount?: number | null;
  chart?: DashboardChart[] | null;
  deliveyType?: DashboardType[] | null;
  paymentType?: DashboardType[] | null;
  orderType?: DashboardType[] | null;
  bestSellingByCount?: DashboardProduct[] | null;
  bestSellingByPrice?: DashboardProduct[] | null;
  topMenuCategory?: DashboardMenuCategory[] | null;
  feedback?: DashboardFeeback;
  viewpointCons?: DashboardFeebackViewpoint[] | null;
  viewpointPros?: DashboardFeebackViewpoint[] | null;
}

export interface DashboardReportQueryResponseResponseMessage {
  data?: DashboardReportQueryResponse;
  status?: string | null;
}

export interface DashboardType {
  /** @format int64 */
  finalPrice?: number | null;
  /** @format int32 */
  count?: number;
  type?: any;
}

export interface DeleteDeliveryHistoryCommand {
  ids?: string[] | null;
}

export interface DeliverOrderByBikerDto {
  /** @format uuid */
  userId?: string | null;
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  historyId?: string | null;
}

export interface DeliveryFeeResponse {
  succeeded?: boolean;
  errors?: string[] | null;
  /** @format int32 */
  deliveryFee?: number | null;
  /** @format date-time */
  eta?: string | null;
}

export interface DeliveryFeeResponseResponseMessage {
  data?: DeliveryFeeResponse;
  status?: string | null;
}

export interface DeliveryHistoryQueryResponse {
  id?: string | null;
  provider?: DeliveryProvider;
  tripId?: string | null;
  state?: DeliveryState;
  bikerName?: string | null;
  /** @format date-time */
  createdAt?: string | null;
}

export enum DeliveryState {
  REQUESTED = 'REQUESTED',
  ACCEPTED = 'ACCEPTED',
  PICKED_UP = 'PICKED_UP',
  DELIVERED = 'DELIVERED',
  CANCELED_BY_PROVIDER = 'CANCELED_BY_PROVIDER',
  CANCELED_BY_US = 'CANCELED_BY_US',
  ASSIGNED = 'ASSIGNED',
  ATRESTAURANT = 'ATRESTAURANT',
  TIMED_OUT = 'TIMED_OUT',
  ACK = 'ACK',
}

export interface DiningTableCategoryQueryResponse {
  id?: string | null;
  name?: string | null;
  isActive?: boolean;
}

export interface DiningTableCategoryQueryResponsePaginatedList {
  items?: DiningTableCategoryQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiningTableCategoryQueryResponsePaginatedListResponseMessage {
  data?: DiningTableCategoryQueryResponsePaginatedList;
  status?: string | null;
}

export interface DiningTableCategoryQueryResponseResponseMessage {
  data?: DiningTableCategoryQueryResponse;
  status?: string | null;
}

export interface DiningTableQueryResponse {
  id?: string | null;
  diningTableCategoryId?: string | null;
  name?: string | null;
  isActive?: boolean;
  qrLink?: string | null;
}

export interface DiningTableQueryResponsePaginatedList {
  items?: DiningTableQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiningTableQueryResponsePaginatedListResponseMessage {
  data?: DiningTableQueryResponsePaginatedList;
  status?: string | null;
}

export interface DiningTableReserveOrderQueryResponse {
  orderId?: string | null;
  /** @format int32 */
  orderState?: number | null;
}

export interface DiningTableReserveQueryResponse {
  id?: string | null;
  diningTableCategoryId?: string | null;
  diningTableCategoryName?: string | null;
  name?: string | null;
  isActive?: boolean;
  qrLink?: string | null;
  order?: DiningTableReserveOrderQueryResponse;
  reserve?: TableState;
}

export interface DiningTableReserveQueryResponseListResponseMessage {
  data?: DiningTableReserveQueryResponse[] | null;
  status?: string | null;
}

export interface DiningTablesOrdersDetailReportResponse {
  /** @format int32 */
  factorNumber?: number | null;
  orderTypeTitle?: string | null;
  customerName?: string | null;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  paymentMethod?: string | null;
  tableNumber?: string | null;
}

export interface DiningTablesOrdersDetailReportResponsePaginatedList {
  items?: DiningTablesOrdersDetailReportResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DiningTablesOrdersDetailReportResponsePaginatedListResponseMessage {
  data?: DiningTablesOrdersDetailReportResponsePaginatedList;
  status?: string | null;
}

export interface DiningTablesOrdersReportResponse {
  categoryName?: string | null;
  /** @format int32 */
  totalOrders?: number;
  /** @format int64 */
  totalOrdersAmount?: number | null;
  /** @format int32 */
  totalOnlineOrdersCount?: number;
  /** @format int64 */
  totalOnlineOrdersAmount?: number | null;
  /** @format int32 */
  totalCardOrdersCount?: number;
  /** @format int64 */
  totalCardOrdersAmount?: number | null;
  /** @format int32 */
  totalCashOrdersCount?: number;
  /** @format int64 */
  totalCashOrdersAmount?: number | null;
  /** @format int64 */
  totalOrdersTips?: number | null;
  /** @format int32 */
  totalOrdersWithTipCount?: number;
}

export interface DiningTablesOrdersReportResponseListResponseMessage {
  data?: DiningTablesOrdersReportResponse[] | null;
  status?: string | null;
}

export interface DinnigTableListQueryRespone {
  id?: string | null;
  name?: string | null;
  qrLink?: string | null;
  isActive?: boolean;
  diningTableCategoryId?: string | null;
  diningTableCategoryName?: string | null;
}

export interface DinnigTableListQueryResponeListResponseMessage {
  data?: DinnigTableListQueryRespone[] | null;
  status?: string | null;
}

export interface DinnigTableListQueryResponePaginatedList {
  items?: DinnigTableListQueryRespone[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DinnigTableListQueryResponePaginatedListResponseMessage {
  data?: DinnigTableListQueryResponePaginatedList;
  status?: string | null;
}

export interface DinnigTableListQueryResponeResponseMessage {
  data?: DinnigTableListQueryRespone;
  status?: string | null;
}

export interface DiscountCodeDto {
  id?: string | null;
  /** @format int32 */
  usageCount?: number | null;
  /** @format date-time */
  expiration?: string | null;
  type?: string | null;
  /** @format int32 */
  value?: number | null;
  /** @format int32 */
  cap?: number | null;
  code?: string | null;
  active?: boolean | null;
  /** @format int32 */
  usageLimitPerUser?: number;
  /** @format int32 */
  vendorDeal?: number;
  freeItems?: OrderFreeItemQueryResponse[] | null;
}

export enum DiscountType {
  MONEY = 'MONEY',
  PERCENTAGE = 'PERCENTAGE',
  FREESHIPPING = 'FREESHIPPING',
  FREEITEM = 'FREEITEM',
}

export interface EarnPointEvent {
  /** @format int32 */
  point?: number;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface EarnPointEventResponseMessage {
  data?: EarnPointEvent;
  status?: string | null;
}

export interface EditPostPaidOrderCommand {
  /** @format uuid */
  orderId?: string;
  paymentMethod?: PaymentMethod;
  deliveryType?: DeliveryType;
  /** @format uuid */
  posTerminalId?: string | null;
  discountCode?: string | null;
  tableId?: string | null;
  /** @format int32 */
  numberOfCustomer?: number;
  /** @format int32 */
  tip?: number;
  description?: string | null;
  customerId?: string | null;
  /** @format int32 */
  preparationTime?: number;
  addressId?: string | null;
  /** @format int32 */
  packagingCost?: number | null;
  /** @format int32 */
  discountAmount?: number | null;
  discountType?: DiscountType;
  /** @format int32 */
  serviceFee?: number;
  /** @format int32 */
  deliveryCost?: number;
  note?: string | null;
  orderItems?: OrderItemsDto[] | null;
}

export enum ExpressTripStatusType {
  INITIATED = 'INITIATED',
  TRIPREQUESTED = 'TRIPREQUESTED',
  BIKERASSIGNED = 'BIKERASSIGNED',
  BIKERACCEPTED = 'BIKERACCEPTED',
  ATSOURCE = 'ATSOURCE',
  PICKEDUP = 'PICKEDUP',
  ATDESTINATION = 'ATDESTINATION',
  DELIVERED = 'DELIVERED',
  CANCELED = 'CANCELED',
  TIMEOUT = 'TIMEOUT',
  INTERRUPTED = 'INTERRUPTED',
  BATCHASSIGNED = 'BATCHASSIGNED',
}

export interface FreeDiningTableCommand {
  tableId?: string | null;
}

export interface InitialPOSPaymentCommand {
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  posId?: string;
}

export interface Location {
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface ManifestItem {
  name?: string | null;
  /** @format int32 */
  quantity?: number;
}

export interface ManualPaymentByPOSCommand {
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  posId?: string;
}

export interface MostSalesItemQueryResponse {
  title?: string | null;
  /** @format int64 */
  count?: number;
  /** @format int64 */
  basePrice?: number;
  /** @format int64 */
  totalSales?: number;
  categoryId?: string | null;
  thirdPartyCode?: string | null;
  code?: string | null;
}

export interface MostSalesItemQueryResponseListResponseMessage {
  data?: MostSalesItemQueryResponse[] | null;
  status?: string | null;
}

export interface MostSalesItemQueryResponsePaginatedList {
  items?: MostSalesItemQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface MostSalesItemQueryResponsePaginatedListResponseMessage {
  data?: MostSalesItemQueryResponsePaginatedList;
  status?: string | null;
}

export interface MyOrderListQueryResponse {
  id?: string | null;
  vendorName?: string | null;
  billNumber?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  finalAmount?: number;
}

export interface MyOrderListQueryResponsePaginatedList {
  items?: MyOrderListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface MyOrderListQueryResponsePaginatedListResponseMessage {
  data?: MyOrderListQueryResponsePaginatedList;
  status?: string | null;
}

export interface OrderCreatedResponse {
  id?: string | null;
  /** @format int32 */
  finalPrice?: number;
}

export interface OrderCreatedResponseResponseMessage {
  data?: OrderCreatedResponse;
  status?: string | null;
}

export interface OrderFreeItemQueryResponse {
  id?: string | null;
}

export interface OrderHistoryQueryResponse {
  state?: string | null;
  username?: string | null;
  /** @format date-time */
  createAt?: string;
}

export interface OrderHistoryQueryResponseListResponseMessage {
  data?: OrderHistoryQueryResponse[] | null;
  status?: string | null;
}

export interface OrderItemDto {
  id?: string | null;
  /** @format int32 */
  count?: number;
}

export interface OrderItemQueryDto {
  item?: string | null;
  /** @format int64 */
  previousCount?: number;
  /** @format int64 */
  currentCount?: number;
  toppings?: OrderItemToppingQueryDto[] | null;
}

export interface OrderItemQueryResponse {
  id?: string | null;
  menuItemId?: string | null;
  title?: string | null;
  /** @format int64 */
  count?: number;
  /** @format int64 */
  price?: number;
  /** @format int64 */
  discount?: number;
  /** @format int64 */
  packagingCost?: number;
  menuItemTitle?: string | null;
  withTax?: boolean;
  toppings?: OrderItemToppingQueryResponse[] | null;
}

export interface OrderItemToppingQueryDto {
  title?: string | null;
  /** @format int64 */
  previousCount?: number;
  /** @format int64 */
  currentCount?: number;
}

export interface OrderItemToppingQueryResponse {
  id?: string | null;
  toppingId?: string | null;
  title?: string | null;
  /** @format int64 */
  count?: number;
  /** @format int64 */
  price?: number;
}

export interface OrderItemToppingUpdatedResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  newCount?: number;
  /** @format int32 */
  price?: number;
}

export interface OrderItemToppingsDto {
  toppingId?: string | null;
  /** @format int32 */
  count?: number;
}

export interface OrderItemUpdatedResponse {
  id?: string | null;
  menuItemId?: string | null;
  title?: string | null;
  /** @format int32 */
  count?: number;
  /** @format int32 */
  newCount?: number;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  packagingCost?: number;
  menuItemTitle?: string | null;
  withTax?: boolean;
  toppings?: OrderItemToppingUpdatedResponse[] | null;
}

export interface OrderItemsDto {
  id?: string | null;
  menuItemId?: string | null;
  /** @format int32 */
  count?: number;
  orderItemToppings?: OrderItemToppingsDto[] | null;
}

export interface OrderItemsPrinterStationSalesReportResponse {
  printerStationTitle?: string | null;
  itemTitle?: string | null;
  /** @format int32 */
  itemCount?: number;
  /** @format int64 */
  itemAveragePrice?: number;
  /** @format int64 */
  itemTotalPrice?: number;
  /** @format int64 */
  itemTotalToppingPrice?: number;
  /** @format int64 */
  itemTotalTax?: number;
  /** @format int64 */
  netTotalItemPrice?: number;
  /** @format int64 */
  itemTotalDiscount?: number;
  /** @format int64 */
  grossTotalItemPrice?: number;
}

export interface OrderItemsPrinterStationSalesReportResponseListResponseMessage {
  data?: OrderItemsPrinterStationSalesReportResponse[] | null;
  status?: string | null;
}

export interface OrderItemsSalesReportResponse {
  categoryTitle?: string | null;
  itemTitle?: string | null;
  thirdPartyCode?: string | null;
  /** @format int32 */
  itemCount?: number;
  /** @format int64 */
  itemAveragePrice?: number;
  /** @format int64 */
  itemTotalPrice?: number;
  /** @format int64 */
  itemTotalToppingPrice?: number;
  /** @format int64 */
  itemTotalTax?: number;
  /** @format int64 */
  netTotalItemPrice?: number;
  /** @format int64 */
  itemTotalDiscount?: number;
  /** @format int64 */
  grossTotalItemPrice?: number;
}

export interface OrderItemsSalesReportResponseListResponseMessage {
  data?: OrderItemsSalesReportResponse[] | null;
  status?: string | null;
}

export interface OrderListQueryResponse {
  id?: string | null;
  billNumber?: string | null;
  tableNumber?: string | null;
  deliveryType?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  /** @format int64 */
  numberOfCustomer?: number;
  edited?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  preparationTime?: string | null;
  /** @format date-time */
  printTime?: string | null;
  deliveryHistory?: DeliveryHistoryQueryResponse;
  orderHistoryState?: string | null;
  /** @format int64 */
  finalAmount?: number;
  orderType?: OrderType;
  paymentMethod?: PaymentMethod;
  /** @format int32 */
  lastState?: number | null;
  /** @format int32 */
  factorNumber?: number | null;
  addressDto?: AddressDto;
  addressId?: string | null;
  addressTitle?: string | null;
  addressDescription?: string | null;
  /** @format double */
  addressLatitude?: number | null;
  /** @format double */
  addressLongitude?: number | null;
  orderItems?: OrderItemQueryResponse[] | null;
  /** @format int64 */
  deliveryCost?: number;
  /** @format int64 */
  discount?: number;
  /** @format int64 */
  packagingCost?: number;
  /** @format int64 */
  tax?: number;
  /** @format int64 */
  serviceCost?: number;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format int64 */
  discountAmount?: number | null;
  customerId?: string | null;
  diningTableId?: string | null;
  description?: string | null;
  submitUrl?: string | null;
  /** @format int64 */
  thirdPartyDeliveryCost?: number | null;
  /** @format int64 */
  vendorDeliveryShare?: number;
  /** @format int64 */
  tip?: number;
  phoneNumber?: string | null;
  /** @format int64 */
  refundAmount?: number | null;
  discountCode?: DiscountCodeDto;
  discountType?: DiscountType;
  /** @format date-time */
  bikerStartAt?: string | null;
  /** @format int32 */
  serviceFee?: number;
  bikerName?: string | null;
  canEdited?: boolean;
  note?: string | null;
  /** @format date-time */
  deliveryEta?: string | null;
  vendorName?: string | null;
  vendorSubdomain?: string | null;
}

export interface OrderListQueryResponsePaginatedList {
  items?: OrderListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface OrderListQueryResponsePaginatedListResponseMessage {
  data?: OrderListQueryResponsePaginatedList;
  status?: string | null;
}

export interface OrderPatchRequest {
  operation?: string | null;
  path?: string | null;
  value?: string | null;
  paymentMethod?: PaymentMethod;
  /** @format int32 */
  preparationTime?: number | null;
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  posTerminalId?: string | null;
  /** @format int32 */
  tip?: number | null;
}

export interface OrderPaymentLinkResponse {
  /** @format uuid */
  id?: string;
  orderId?: string | null;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  vendorName?: string | null;
  vendorLogo?: string | null;
  subDomain?: string | null;
  /** @format int64 */
  finalPrice?: number;
}

export interface OrderPaymentLinkResponseResponseMessage {
  data?: OrderPaymentLinkResponse;
  status?: string | null;
}

export interface OrderPreviewForBikerViewModel {
  billNumber?: string | null;
  /** @format int32 */
  factorNumber?: number | null;
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  finalPrice?: number | null;
  firstName?: string | null;
  lastName?: string | null;
  addressDescription?: string | null;
  orderType?: OrderType;
  phoneNumber?: string | null;
  id?: string | null;
  deliveryType?: string | null;
  orderHistoryState?: string | null;
  deliveryHistory?: DeliveryHistoryQueryResponse;
}

export interface OrderPreviewForBikerViewModelResponseMessage {
  data?: OrderPreviewForBikerViewModel;
  status?: string | null;
}

export interface OrderQueryResponse {
  id?: string | null;
  /** @format int64 */
  deliveryCost?: number;
  /** @format int64 */
  discount?: number;
  /** @format int64 */
  packagingCost?: number;
  /** @format int64 */
  tax?: number;
  /** @format int64 */
  numberOfCustomer?: number;
  /** @format int64 */
  serviceCost?: number;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format int64 */
  discountAmount?: number | null;
  customerId?: string | null;
  diningTableId?: string | null;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  description?: string | null;
  submitUrl?: string | null;
  /** @format date-time */
  preparationTime?: string | null;
  /** @format date-time */
  printTime?: string | null;
  /** @format int64 */
  thirdPartyDeliveryCost?: number | null;
  /** @format int64 */
  vendorDeliveryShare?: number;
  tableNumber?: string | null;
  /** @format int64 */
  tip?: number;
  deliveryType?: string | null;
  addressId?: string | null;
  addressTitle?: string | null;
  addressDescription?: string | null;
  /** @format double */
  addressLatitude?: number | null;
  /** @format double */
  addressLongitude?: number | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  orderHistoryState?: string | null;
  /** @format int64 */
  refundAmount?: number | null;
  /** @format int32 */
  factorNumber?: number | null;
  discountCode?: DiscountCodeDto;
  edited?: boolean;
  canEdited?: boolean;
  note?: string | null;
  orderType?: OrderType;
  paymentMethod?: PaymentMethod;
  discountType?: DiscountType;
  deliveryHistory?: DeliveryHistoryQueryResponse;
  orderItems?: OrderItemQueryResponse[] | null;
  /** @format date-time */
  bikerStartAt?: string | null;
  /** @format int32 */
  serviceFee?: number;
  bikerName?: string | null;
}

export interface OrderQueryResponseListResponseMessage {
  data?: OrderQueryResponse[] | null;
  status?: string | null;
}

export interface OrderQueryResponseResponseMessage {
  data?: OrderQueryResponse;
  status?: string | null;
}

export interface OrderReportPerOrderTypeItemDto {
  orderTypeTitle?: string | null;
  type?: OrderType;
  /** @format int64 */
  totalItemPrice?: number;
  /** @format int64 */
  totalPackagingCost?: number;
  /** @format int64 */
  totalDiscount?: number;
  /** @format int64 */
  totalTax?: number;
  /** @format int64 */
  totalDeliveryCost?: number;
  /** @format int64 */
  totalTip?: number;
  /** @format int64 */
  totalSale?: number;
  /** @format int64 */
  totalServiceCost?: number;
  /** @format int64 */
  totalServiceFee?: number;
  /** @format int64 */
  totalOrder?: number;
  /** @format int64 */
  totalOrderDiscountVendorShare?: number;
  /** @format int64 */
  totalOrderDiscountSnappFoodShare?: number;
  /** @format int64 */
  totalOrderItemDiscountVendorShare?: number;
  /** @format int64 */
  totalOrderItemDiscountSnappFoodShare?: number;
}

export interface OrderReportPerOrderTypeQueryResponse {
  orderTypeItems?: OrderReportPerOrderTypeItemDto[] | null;
  /** @format int64 */
  totalItemPrice?: number;
  /** @format int64 */
  totalPackagingCost?: number;
  /** @format int64 */
  totalDiscount?: number;
  /** @format int64 */
  totalTax?: number;
  /** @format int64 */
  totalDeliveryCost?: number;
  /** @format int64 */
  totalTip?: number;
  /** @format int64 */
  totalSale?: number;
  /** @format int64 */
  totalServiceCost?: number;
  /** @format int64 */
  totalServiceFee?: number;
  /** @format int64 */
  totalOrder?: number;
  /** @format int64 */
  totalSnappFoodCouponDiscountShare?: number;
  /** @format int64 */
  totalVendorCouponDiscountShare?: number;
  /** @format int64 */
  totalSnappFoodOrderItemDiscountShare?: number;
  /** @format int64 */
  totalVendorOrderItemDiscountShare?: number;
}

export interface OrderReportPerOrderTypeQueryResponseResponseMessage {
  data?: OrderReportPerOrderTypeQueryResponse;
  status?: string | null;
}

export interface OrderReportPerUserItemDto {
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  discount?: number;
  billNumber?: string | null;
  /** @format int64 */
  finalPrice?: number;
}

export interface OrderReportPerUserQueryResponse {
  orders?: OrderReportPerUserItemDto[] | null;
  /** @format int64 */
  totalFinalPrice?: number;
  /** @format int64 */
  totalDiscount?: number;
  /** @format int64 */
  totalOrder?: number;
}

export interface OrderReportPerUserQueryResponseListResponseMessage {
  data?: OrderReportPerUserQueryResponse[] | null;
  status?: string | null;
}

export interface OrderReportQueryResponse {
  /** @format int64 */
  sumOfItems?: number;
  /** @format int64 */
  sumOfPackagingCost?: number;
  /** @format int64 */
  sumOfDiscount?: number;
  /** @format int64 */
  sumOfTax?: number;
  /** @format int64 */
  sumOfDeliveryCost?: number;
  /** @format int64 */
  sumOfTip?: number;
  /** @format int64 */
  sumOfServiceFee?: number;
  /** @format int64 */
  sumOfTotal?: number;
  /** @format int64 */
  sumOfServiceCost?: number;
  /** @format int64 */
  totalOrder?: number;
  /** @format int64 */
  totalOnlineOrders?: number;
  /** @format int64 */
  totalOfflineOrders?: number;
  /** @format int64 */
  sumOfOnlineOrders?: number;
  /** @format int64 */
  sumOfOfflineOrders?: number;
  /** @format int64 */
  totalUnpaidOrdersCount?: number;
  /** @format int64 */
  unpaidOrdersTotalAmount?: number;
  /** @format int64 */
  totalCashOrdersCount?: number;
  /** @format int64 */
  totalFoodroOrdersCount?: number;
  /** @format int64 */
  totalCreditOrdersCount?: number;
  /** @format int64 */
  totalCardOrdersCount?: number;
  /** @format int64 */
  totalOnlineOrdersCount?: number;
  /** @format int64 */
  cashOrdersTotalAmount?: number;
  /** @format int64 */
  foodroOrdersTotalAmount?: number;
  /** @format int64 */
  creditOrdersTotalAmount?: number;
  /** @format int64 */
  unPaidCreditOrdersTotalAmount?: number;
  /** @format int64 */
  cardOrdersTotalAmount?: number;
  /** @format int64 */
  onlineOrdersTotalAmount?: number;
  /** @format int64 */
  orderCouponDiscountVendorShare?: number;
  /** @format int64 */
  orderCouponDiscountSnappFoodShare?: number;
  /** @format int64 */
  orderItemsDiscountVendorShare?: number;
  /** @format int64 */
  orderItemsDiscountSnappFoodShare?: number;
}

export interface OrderReportQueryResponseResponseMessage {
  data?: OrderReportQueryResponse;
  status?: string | null;
}

export interface OrderReportSeparationPerDayDto {
  items?: ReportOrderSeparationPerDayItemDto[] | null;
  /** @format int64 */
  totalFinalPricePerDay?: number;
  /** @format int64 */
  totalOrderCountPerDay?: number;
  /** @format int64 */
  totalTaxPerDay?: number;
  /** @format int64 */
  totalDiscountPerDay?: number;
}

export interface OrderReportSeparationPerDayQueryResponse {
  orders?: OrderReportSeparationPerDayDto[] | null;
  /** @format int64 */
  totalFinalPrice?: number;
  /** @format int64 */
  totalDiscount?: number;
  /** @format int64 */
  totalTax?: number;
}

export interface OrderReportSeparationPerDayQueryResponsePaginatedList {
  items?: OrderReportSeparationPerDayQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface OrderReportSeparationPerDayQueryResponsePaginatedListResponseMessage {
  data?: OrderReportSeparationPerDayQueryResponsePaginatedList;
  status?: string | null;
}

export interface OrderSettlementQueryResponse {
  id?: string | null;
  /** @format int64 */
  deliveryCost?: number;
  /** @format int64 */
  discount?: number;
  /** @format int64 */
  packagingCost?: number;
  /** @format int64 */
  numberOfCustomer?: number;
  deliverType?: string | null;
  /** @format int64 */
  tax?: number;
  /** @format int64 */
  tip?: number;
  orderType?: string | null;
  /** @format int64 */
  serviceCost?: number;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  state?: string | null;
  deliveryProvider?: string | null;
  /** @format int64 */
  thirdPartyDeliveryCost?: number | null;
  /** @format int64 */
  vendorDeliveryShare?: number;
  /** @format int64 */
  sumOfItemsPrice?: number;
  /** @format int64 */
  totalAmount?: number;
  /** @format int64 */
  paidAmount?: number;
  /** @format int64 */
  revenue?: number;
  discountCode?: DiscountCodeDto;
}

export interface OrderSettlementQueryResponsePaginatedList {
  items?: OrderSettlementQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface OrderSettlementQueryResponsePaginatedListResponseMessage {
  data?: OrderSettlementQueryResponsePaginatedList;
  status?: string | null;
}

export enum OrderState {
  SUBMITTED = 'SUBMITTED',
  PAID = 'PAID',
  CONFIRMED = 'CONFIRMED',
  DELIVERED = 'DELIVERED',
  REJECTED = 'REJECTED',
  FINISHED = 'FINISHED',
  DELIVERING = 'DELIVERING',
  READYTOSHIPMENT = 'READYTOSHIPMENT',
  READYTOPICKUP = 'READYTOPICKUP',
  READYTOSERVE = 'READYTOSERVE',
  NEEDFORCALL = 'NEEDFORCALL',
}

export interface OrderUpdatedEvent {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  deliveryCost?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  tax?: number;
  /** @format int32 */
  finalPrice?: number;
  hasNewItems?: boolean;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  description?: string | null;
  note?: string | null;
  submitUrl?: string | null;
  paymentMethod?: string | null;
  /** @format date-time */
  preparationTime?: string | null;
  /** @format date-time */
  printTime?: string | null;
  /** @format int32 */
  thirdPartyDeliveryCost?: number | null;
  /** @format int32 */
  vendorDeliveryShare?: number;
  tableNumber?: string | null;
  /** @format int32 */
  tip?: number;
  deliveryType?: string | null;
  addressId?: string | null;
  addressTitle?: string | null;
  addressDescription?: string | null;
  /** @format double */
  addressLatitude?: number | null;
  /** @format double */
  addressLongitude?: number | null;
  phoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format int32 */
  factorNumber?: number | null;
  orderHistoryState?: string | null;
  orderItems?: OrderItemUpdatedResponse[] | null;
  /** @format date-time */
  publishedOn?: string | null;
  /** @format int32 */
  serviceFee?: number;
}

export interface OrderUpdatedEventResponseMessage {
  data?: OrderUpdatedEvent;
  status?: string | null;
}

export interface PaidReportQueryResponse {
  /** @format int64 */
  totalPaidOrdersCount?: number;
  /** @format int64 */
  paidOrdersTotalAmount?: number;
}

export interface PaidReportQueryResponseResponseMessage {
  data?: PaidReportQueryResponse;
  status?: string | null;
}

export interface Payment {
  payment_type?: string | null;
  /** @format int64 */
  price?: number | null;
}

export enum PaymentMethod {
  CARD = 'CARD',
  CASH = 'CASH',
  ONLINE = 'ONLINE',
  UNPAID = 'UNPAID',
  FOODRO = 'FOODRO',
  CREDIT = 'CREDIT',
}

export enum PeriodTime {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  LAST7DAY = 'LAST_7_DAY',
  LAST30DAY = 'LAST_30_DAY',
  CURRENT_MONTH = 'CURRENT_MONTH',
}

export interface PickUp {
  name?: string | null;
  phone_number?: string | null;
  image?: string | null;
  address?: string | null;
  location?: Location;
  deadline?: string | null;
}

export interface PosTransactionOrderDetail {
  posTitle?: string | null;
  providerName?: string | null;
  /** @format int32 */
  totalOrders?: number;
  /** @format int64 */
  amount?: number;
  subdomain?: string | null;
}

export interface PosTransactionOrderQueryResponse {
  posTransactionOrderDetails?: PosTransactionOrderDetail[] | null;
  /** @format int64 */
  totalAmount?: number;
}

export interface PosTransactionOrderQueryResponseResponseMessage {
  data?: PosTransactionOrderQueryResponse;
  status?: string | null;
}

export interface QuestionPoolQueryResponse {
  /** @format uuid */
  id?: string;
  text?: string | null;
  type?: QuestionType;
  /** @format date-time */
  createdAt?: string;
}

export interface QuestionPoolQueryResponseListResponseMessage {
  data?: QuestionPoolQueryResponse[] | null;
  status?: string | null;
}

export interface QuestionQueryResponse {
  /** @format uuid */
  surveyQuestionId?: string;
  /** @format uuid */
  questionId?: string;
  text?: string | null;
  type?: QuestionType;
}

export enum QuestionType {
  MULTIPLECHOICE = 'MULTIPLECHOICE',
  TEXT = 'TEXT',
  RATING = 'RATING',
}

export interface RefundOrderCommand {
  /** @format uuid */
  orderId?: string;
  orderItems?: OrderItemDto[] | null;
  /** @format int32 */
  finalPrice?: number;
  /** @format int32 */
  serviceFee?: number;
  discountCode?: string | null;
  /** @format int32 */
  discountAmount?: number | null;
  discountType?: DiscountType;
}

export interface RefundOrderReportQueryResponse {
  /** @format date-time */
  createdAt?: string | null;
  items?: OrderItemQueryDto[] | null;
  fullName?: string | null;
}

export interface RefundOrderReportQueryResponseListResponseMessage {
  data?: RefundOrderReportQueryResponse[] | null;
  status?: string | null;
}

export interface ReportOrderSeparationPerDayItemDto {
  /** @format date-time */
  createdAt?: string;
  /** @format int64 */
  tax?: number;
  /** @format int64 */
  discount?: number;
  /** @format int32 */
  count?: number;
  /** @format int64 */
  finalPrice?: number;
  type?: OrderType;
}

export interface RequestNewTripCommand {
  orderCode?: string | null;
}

export interface RequestTripEvent {
  /** @format int32 */
  deliveryFee?: number | null;
  /** @format date-time */
  eta?: string | null;
  status?: string | null;
  succeeded?: boolean;
  bordarTripId?: string | null;
  errors?: string[] | null;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface RequestTripEventResponseMessage {
  data?: RequestTripEvent;
  status?: string | null;
}

export interface ResponseQuestionsModel {
  /** @format uuid */
  questionId?: string;
  text?: string | null;
}

export interface ResponseSurveyApiModel {
  /** @format uuid */
  orderId?: string;
  /** @format uuid */
  surveyId?: string;
  answers?: ResponseQuestionsModel[] | null;
}

export interface SettlementQueryResponse {
  id?: string | null;
  bankTransactionId?: string | null;
  vendorId?: string | null;
  receiptUrl?: string | null;
  /** @format date-time */
  doneTimePrediction?: string;
  /** @format double */
  amount?: number;
  /** @format double */
  wage?: number;
  note?: string | null;
  status?: string | null;
  /** @format date-time */
  createdAt?: string;
}

export interface SettlementQueryResponsePaginatedList {
  items?: SettlementQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface SettlementQueryResponsePaginatedListResponseMessage {
  data?: SettlementQueryResponsePaginatedList;
  status?: string | null;
}

export interface SettlementQueryResponseResponseMessage {
  data?: SettlementQueryResponse;
  status?: string | null;
}

export interface SnappFoodOrderReportQueryResponse {
  /** @format int64 */
  sumOfSnappFoodOrders?: number;
  /** @format int64 */
  totalSnappFoodOrders?: number;
}

export interface SnappFoodOrderReportQueryResponseResponseMessage {
  data?: SnappFoodOrderReportQueryResponse;
  status?: string | null;
}

export enum SnappPayType {
  DIRECTDEBIT = 'DIRECTDEBIT',
  POSTPAID = 'POSTPAID',
}

export interface StaffOrdersDetail {
  /** @format int32 */
  factorNumber?: number | null;
  orderTypeTitle?: string | null;
  customerName?: string | null;
  /** @format int64 */
  finalPrice?: number | null;
  /** @format date-time */
  createdAt?: string;
  billNumber?: string | null;
  tableNumber?: string | null;
  paymentMethod?: string | null;
}

export interface StaffOrdersDetailPaginatedList {
  items?: StaffOrdersDetail[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface StaffOrdersDetailPaginatedListResponseMessage {
  data?: StaffOrdersDetailPaginatedList;
  status?: string | null;
}

export interface StaffOrdersReportReponse {
  userId?: string | null;
  username?: string | null;
  /** @format int32 */
  totalOrdersCount?: number;
  /** @format int64 */
  totalOrdersAmount?: number | null;
  /** @format int32 */
  totalCashPaymentMethodOrdersCount?: number;
  /** @format int64 */
  totalCashPaymentMethodOrdersAmount?: number | null;
  /** @format int32 */
  totalCardPaymentMethodOrdersCount?: number;
  /** @format int64 */
  totalCardPaymentMethodOrdersAmount?: number | null;
  /** @format int64 */
  totalOrdersWithTipsAmount?: number;
  /** @format int64 */
  totalOrdersWithTipsCount?: number;
}

export interface StaffOrdersReportReponseListResponseMessage {
  data?: StaffOrdersReportReponse[] | null;
  status?: string | null;
}

export interface SurveyQueryResponse {
  /** @format uuid */
  id?: string;
  vendorId?: string | null;
  isActive?: boolean;
  /** @format date-time */
  createdAt?: string;
  questions?: QuestionQueryResponse[] | null;
}

export interface SurveyQueryResponseResponseMessage {
  data?: SurveyQueryResponse;
  status?: string | null;
}

export enum TableState {
  FREE = 'FREE',
  RESERVED = 'RESERVED',
}

export interface ToggleActivationTableCommand {
  tableId?: string | null;
  isActive?: boolean;
}

export interface TransactionQueryResponse {
  id?: string | null;
  note?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  wage?: number;
  status?: string | null;
  paymentMethod?: string | null;
  type?: string | null;
  provider?: string | null;
  /** @format date-time */
  createdAt?: string;
}

export interface TransactionQueryResponseListResponseMessage {
  data?: TransactionQueryResponse[] | null;
  status?: string | null;
}

export interface TransactionQueryResponsePaginatedList {
  items?: TransactionQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface TransactionQueryResponsePaginatedListResponseMessage {
  data?: TransactionQueryResponsePaginatedList;
  status?: string | null;
}

export interface TripResponse {
  id?: string | null;
  is_round_trip?: boolean | null;
  /** @format date-time */
  created_at?: string | null;
  /** @format date-time */
  assigned_at?: string | null;
  /** @format date-time */
  arrived_at?: string | null;
  /** @format date-time */
  picked_up_at?: string | null;
  /** @format date-time */
  departed_at?: string | null;
  state?: string | null;
  pickup?: PickUp;
  area?: Area;
  /** @format double */
  delivery_cost?: number | null;
  courier?: Courier;
  courses?: CourseResponse[] | null;
}

export interface UnAssignedOrdersListQueryResponse {
  id?: string | null;
  billNumber?: string | null;
  deliveryType?: string | null;
  fullName?: string | null;
  /** @format int64 */
  finalAmount?: number;
  orderType?: string | null;
  lastState?: string | null;
  /** @format int32 */
  factorNumber?: number | null;
  address?: string | null;
  deliveryHistory?: DeliveryHistoryQueryResponse;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  preparationTime?: string | null;
  orderItems?: OrderItemQueryResponse[] | null;
}

export interface UnAssignedOrdersListQueryResponseListResponseMessage {
  data?: UnAssignedOrdersListQueryResponse[] | null;
  status?: string | null;
}

export interface UnpaidReportQueryResponse {
  /** @format int64 */
  totalUnpaidOrdersCount?: number;
  /** @format int64 */
  unpaidOrdersTotalAmount?: number;
}

export interface UnpaidReportQueryResponseResponseMessage {
  data?: UnpaidReportQueryResponse;
  status?: string | null;
}

export interface UpdateBankConfigurationCommand {
  bankConfig?: BankType[] | null;
  preSelectedProvider?: PaymentServiceType;
}

export interface UpdateBordarDeliveryHistoryCommand {
  code?: string | null;
  status?: ExpressTripStatusType;
  bikerName?: string | null;
}

export interface UpdateDeliveryHistoryCommand {
  event?: string | null;
  trip?: TripResponse;
}

export interface UpdateDiningTableCategoryRequest {
  id?: string | null;
  name?: string | null;
}

export interface UpdateDiningTableRequest {
  id?: string | null;
  tableName?: string | null;
  diningTableCategoryId?: string | null;
}

export interface UpdateStatusTransactionCommand {
  orderId?: string[] | null;
}

export interface UpdateSurveyRequest {
  /** @format uuid */
  id?: string;
  isActive?: boolean;
  questionId?: string[] | null;
}

export interface UserBalanceEvent {
  isValid?: boolean;
  /** @format int64 */
  amount?: number;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface UserBalanceEventResponseMessage {
  data?: UserBalanceEvent;
  status?: string | null;
}

export interface UserPointEvent {
  /** @format int32 */
  point?: number | null;
  isActive?: boolean;
  /** @format date-time */
  publishedOn?: string | null;
}

export interface UserPointEventResponseMessage {
  data?: UserPointEvent;
  status?: string | null;
}

export interface VendorSurveyQueryResponse {
  /** @format uuid */
  id?: string;
  /** @format uuid */
  vendorId?: string;
  isActive?: boolean;
  /** @format date-time */
  createdAt?: string;
}

export interface VendorSurveyQueryResponseListResponseMessage {
  data?: VendorSurveyQueryResponse[] | null;
  status?: string | null;
}

export interface CreateFoodShiftCommand {
  name?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  days?: WeekDay[] | null;
}

export interface FoodShiftQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  name?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  days?: string[] | null;
}

export interface FoodShiftQueryResponseListResponseMessage {
  data?: FoodShiftQueryResponse[] | null;
  status?: string | null;
}

export interface FoodShiftQueryResponsePaginatedList {
  items?: FoodShiftQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface FoodShiftQueryResponsePaginatedListResponseMessage {
  data?: FoodShiftQueryResponsePaginatedList;
  status?: string | null;
}

export interface FoodShiftQueryResponseResponseMessage {
  data?: FoodShiftQueryResponse;
  status?: string | null;
}

export interface FoodShiftToMenuItemQueryResponse {
  id?: string | null;
  title?: string | null;
}

export interface MenuCategoryFilterQueryResponse {
  id?: string | null;
  title?: string | null;
  code?: string | null;
}

export interface MenuCategoryFilterQueryResponseListResponseMessage {
  data?: MenuCategoryFilterQueryResponse[] | null;
  status?: string | null;
}

export interface MenuCategoryQueryResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  order?: number;
  vendorId?: string | null;
  /** @format int64 */
  vmsCategoryId?: number | null;
  isActive?: boolean;
  snappIsActive?: boolean;
  /** @format int32 */
  productCount?: number;
  /** @format int32 */
  printOrder?: number;
  code?: string | null;
}

export interface MenuCategoryQueryResponseListResponseMessage {
  data?: MenuCategoryQueryResponse[] | null;
  status?: string | null;
}

export interface MenuCategoryQueryResponsePaginatedList {
  items?: MenuCategoryQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface MenuCategoryQueryResponsePaginatedListResponseMessage {
  data?: MenuCategoryQueryResponsePaginatedList;
  status?: string | null;
}

export interface MenuCategoryQueryResponseResponseMessage {
  data?: MenuCategoryQueryResponse;
  status?: string | null;
}

export interface MenuCategoryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  title?: string | null;
  /** @format int32 */
  order?: number | null;
}

export interface MenuCategoryToMenuItemQueryResponse {
  id?: string | null;
  title?: string | null;
}

export interface MenuCategoryToMenuItemSiteQueryResponse {
  id?: string | null;
  title?: string | null;
  vendorId?: string | null;
  /** @format int32 */
  order?: number;
  /** @format int64 */
  vmsCategoryId?: number | null;
  isActive?: boolean;
  snappIsActive?: boolean;
  /** @format int32 */
  printOrder?: number;
  code?: string | null;
  menuItems?: MenuItemDto[] | null;
}

export interface MenuCategoryToMenuItemSiteQueryResponseListResponseMessage {
  data?: MenuCategoryToMenuItemSiteQueryResponse[] | null;
  status?: string | null;
}

export interface MenuItemDto {
  id?: string | null;
  /** @format int32 */
  order?: number;
  images?: string[] | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  servePackagingCost?: number;
  available?: boolean;
  active?: boolean | null;
  /** @format int32 */
  minCount?: number;
  /** @format int32 */
  maxCount?: number;
  withTax?: boolean;
  /** @format int32 */
  vmsFoodId?: number | null;
  code?: string | null;
  toppingCategories?: ToppingCategoryDto[] | null;
  tags?: string[] | null;
}

export interface MenuItemListQueryResponse {
  id?: string | null;
  /** @format int32 */
  order?: number;
  images?: string[] | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number;
  available?: boolean;
  /** @format date-time */
  createdAt?: string;
  active?: boolean;
  /** @format int32 */
  vmsFoodId?: number | null;
  thirdPartyCode?: string | null;
  code?: string | null;
  sellChannels?: SellChannel[] | null;
}

export interface MenuItemListQueryResponsePaginatedList {
  items?: MenuItemListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface MenuItemListQueryResponsePaginatedListResponseMessage {
  data?: MenuItemListQueryResponsePaginatedList;
  status?: string | null;
}

export interface MenuItemQueryResponse1 {
  id?: string | null;
  /** @format int32 */
  order?: number;
  images?: string[] | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  servePackagingCost?: number;
  available?: boolean | null;
  active?: boolean | null;
  /** @format int32 */
  minCount?: number;
  /** @format int32 */
  maxCount?: number;
  /** @format int32 */
  vmsFoodId?: number | null;
  thirdPartyCode?: string | null;
  withTax?: boolean;
  sellChannels?: SellChannel[] | null;
  code?: string | null;
  foodShiftToMenuItemQueryResponses?: FoodShiftToMenuItemQueryResponse[] | null;
  menuCategoryToMenuItemQueryResponses?: MenuCategoryToMenuItemQueryResponse[] | null;
  tags?: string[] | null;
}

export interface MenuItemQueryResponseResponseMessage {
  data?: MenuItemQueryResponse1;
  status?: string | null;
}

export interface MenuItemResponse {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number | null;
  /** @format int32 */
  discount?: number | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  active?: boolean | null;
  /** @format int32 */
  order?: number | null;
  /** @format int32 */
  maxCount?: number | null;
  /** @format int32 */
  minCount?: number | null;
  available?: boolean | null;
  softDelete?: boolean | null;
  /** @format int32 */
  packagingCost?: number | null;
  /** @format int32 */
  servePackagingCost?: number | null;
}

export interface MenuItemTag {
  /** @format uuid */
  id?: string;
  title?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface MenuItemTagListResponseMessage {
  data?: MenuItemTag[] | null;
  status?: string | null;
}

export interface MenuItemToToppingCategoryQueryResponse {
  menuItemId?: string | null;
  title?: string | null;
}

export enum PrintLayout {
  KITCHEN = 'KITCHEN',
  CUSTOMER = 'CUSTOMER',
}

export interface PrinterQueryResponse {
  id?: string | null;
  vendorId?: string | null;
  name?: string | null;
  ip?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  softDelete?: boolean;
}

export interface PrinterQueryResponseListResponseMessage {
  data?: PrinterQueryResponse[] | null;
  status?: string | null;
}

export interface PrinterQueryResponseResponseMessage {
  data?: PrinterQueryResponse;
  status?: string | null;
}

export interface PrinterResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  name?: string | null;
  ip?: string | null;
  vendorId?: string | null;
  softDelete?: boolean;
}

export interface PrinterStationQueryResponse {
  id?: string | null;
  printerId?: string | null;
  name?: string | null;
  layoutType?: PrintLayout;
  printOnSubmit?: boolean | null;
  printOnBikerAssignment?: boolean | null;
  /** @format date-time */
  createdAt?: string | null;
  /** @format date-time */
  updatedAt?: string | null;
  softDelete?: boolean | null;
  hasAllItems?: boolean | null;
  menuItems?: MenuItemResponse[] | null;
  menuCategories?: MenuCategoryResponse[] | null;
  printer?: PrinterResponse;
}

export interface PrinterStationQueryResponseListResponseMessage {
  data?: PrinterStationQueryResponse[] | null;
  status?: string | null;
}

export interface PrinterStationQueryResponseResponseMessage {
  data?: PrinterStationQueryResponse;
  status?: string | null;
}

export enum SellChannel {
  QR = 'QR',
  SALON = 'SALON',
}

export interface ToppingCategoryDto {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  toppings?: ToppingDto[] | null;
}

export interface ToppingCategoryListQueryResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  toppingCount?: number;
  /** @format int64 */
  snappToppingGroupId?: number | null;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  /** @format date-time */
  createdAt?: string;
}

export interface ToppingCategoryListQueryResponsePaginatedList {
  items?: ToppingCategoryListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface ToppingCategoryListQueryResponsePaginatedListResponseMessage {
  data?: ToppingCategoryListQueryResponsePaginatedList;
  status?: string | null;
}

export interface ToppingCategoryQueryResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  orderToppingCount?: number;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  /** @format date-time */
  createdAt?: string;
  toppings?: ToppingInToppingCategoryQueryResponse[] | null;
  menuItems?: MenuItemToToppingCategoryQueryResponse[] | null;
}

export interface ToppingCategoryQueryResponseResponseMessage {
  data?: ToppingCategoryQueryResponse;
  status?: string | null;
}

export interface ToppingDto {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  price?: number;
}

export interface ToppingInToppingCategoryQueryResponse {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  price?: number;
}

export interface ToppingListQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  title?: string | null;
  /** @format int64 */
  price?: number;
  categoryName?: string | null;
  /** @format int64 */
  snappToppingId?: number | null;
  isActive?: boolean;
  available?: boolean;
  thirdPartyCode?: string | null;
}

export interface ToppingListQueryResponsePaginatedList {
  items?: ToppingListQueryResponse[] | null;
  /** @format int32 */
  pageNumber?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  totalCount?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface ToppingListQueryResponsePaginatedListResponseMessage {
  data?: ToppingListQueryResponsePaginatedList;
  status?: string | null;
}

export interface ToppingQueryResponse {
  id?: string | null;
  /** @format date-time */
  createdAt?: string;
  title?: string | null;
  /** @format int64 */
  price?: number;
  categoryId?: string | null;
  /** @format int64 */
  snappToppingId?: number | null;
  isActive?: boolean;
  available?: boolean;
  thirdPartyCode?: string | null;
}

export interface ToppingQueryResponseResponseMessage {
  data?: ToppingQueryResponse;
  status?: string | null;
}

export interface UpdateFoodShiftCommand {
  id?: string | null;
  name?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  days?: WeekDay[] | null;
}

export interface AcceptOrderCommand {
  invoiceNo?: string | null;
  deliveryType?: DeliveryType;
  acceptSnappFood?: AcceptOrderSnappFoodDTO;
}

export interface AcceptOrderSnappFoodDTO {
  /** @format int32 */
  riderPickupTime?: number;
  /** @format int32 */
  deliveryTime?: number;
  /** @format int32 */
  delta?: number;
  /** @format int32 */
  packingPrice?: number;
}

export interface AckOrderCommand {
  invoiceNo?: string | null;
}

export interface ActivationCommand {
  toppingId?: string | null;
  snappIsActive?: boolean;
  isDisable?: boolean;
  isDisableUntil?: boolean;
}

export interface CategoryWithMenuItemsDto {
  ropoloCategoryId?: string | null;
  title?: string | null;
  /** @format int32 */
  vmsCategoryId?: number | null;
  /** @format int32 */
  printOrder?: number;
  code?: string | null;
  menuItems?: MenuItemsDto[] | null;
}

export interface CategoryWithMenuItemsDtoListResponseMessage {
  data?: CategoryWithMenuItemsDto[] | null;
  status?: string | null;
}

export interface CreateBrandsCommand {
  vendorId?: string | null;
  /** @format int32 */
  snappFoodVendorId?: number | null;
  snappClientId?: string | null;
  snappClientSecret?: string | null;
  snappUserName?: string | null;
  snappPassword?: string | null;
  ropoloName?: string | null;
  vendorCode?: string | null;
}

export interface CreateCategoryCommand {
  title?: string | null;
  /** @format int32 */
  order?: number;
  isSnappSide?: boolean;
  /** @format int32 */
  printOrder?: number;
  code?: string | null;
}

export interface CreateMenuItemCommand {
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  active?: boolean;
  /** @format int32 */
  order?: number;
  /** @format int32 */
  minCount?: number;
  /** @format int32 */
  maxCount?: number;
  available?: boolean;
  images?: string[] | null;
  tagsId?: string[] | null;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  servePackagingCost?: number;
  categoryIds?: string[] | null;
  shiftIds?: string[] | null;
  sellChannels?: string[] | null;
  isSnappSide?: boolean;
  thirdPartyCode?: string | null;
  withTax?: boolean;
  code?: string | null;
}

export interface CreatePrinterCommand {
  /** @format uuid */
  vendorId?: string;
  name?: string | null;
  ip?: string | null;
}

export interface CreatePrinterResponse {
  id?: string | null;
  name?: string | null;
  ip?: string | null;
  vendorId?: string | null;
  softDelete?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface CreatePrinterResponseResponseMessage {
  data?: CreatePrinterResponse;
  status?: string | null;
}

export interface CreatePrinterStationCommand {
  menuCategoryIds?: string[] | null;
  /** @format uuid */
  printerId?: string;
  name?: string | null;
  menuItemIds?: string[] | null;
  layoutType?: PrintLayout;
  hasAllItems?: boolean;
  printOnSubmit?: boolean;
  printOnBikerAssignment?: boolean;
}

export interface CreatePrinterStationResponse {
  id?: string | null;
  printerId?: string | null;
  name?: string | null;
  printLayout?: PrintLayout;
  printOnSubmit?: boolean;
  printOnBikerAssignment?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  softDelete?: boolean;
  hasAllItems?: boolean;
}

export interface CreatePrinterStationResponseResponseMessage {
  data?: CreatePrinterStationResponse;
  status?: string | null;
}

export interface CreateToppingCategoryCommand {
  title?: string | null;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  menuItemIds?: string[] | null;
}

export interface CreateToppingCommand {
  toppingCategoryId?: string | null;
  title?: string | null;
  /** @format int32 */
  price?: number;
  isActive?: boolean;
  thirdPartyCode?: string | null;
  available?: boolean;
}

export interface DeleteVendorToppingCommand {
  vendorId?: string | null;
}

export interface KeyValue {
  /** @format int32 */
  key?: number;
  value?: string | null;
}

export interface KeyValueListResponseMessage {
  data?: KeyValue[] | null;
  status?: string | null;
}

export interface MenuItemsDto {
  menuItemId?: string | null;
  title?: string | null;
  productCode?: string | null;
  /** @format int32 */
  vmsFoodId?: number | null;
  code?: string | null;
}

export interface NeedForCallOrderCommand {
  invoiceNo?: string | null;
  /** @format int32 */
  reasonId?: number;
  comment?: string | null;
  nonExistentProducts?: NonExistentProducts[] | null;
}

export interface NonExistentProducts {
  /** @format int32 */
  id?: number;
  suggestedProductIds?: number[] | null;
}

export interface PickOrderCommand {
  invoiceNo?: string | null;
}

export interface ProductStatusDto {
  menuItemId?: string | null;
  snappIsActive?: boolean;
  isDisable?: boolean;
  isDisableUntil?: boolean;
}

export interface SnappFoodProductDTO {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  quantity?: number;
  /** @format int32 */
  originPrice?: number;
  /** @format int32 */
  productDiscountSFShare?: number;
  /** @format int32 */
  productDiscountVendorShare?: number;
  /** @format int32 */
  price?: number;
  title?: string | null;
  /** @format int32 */
  discount?: number;
  /** @format double */
  vat?: number;
  barcode?: string | null;
  toppings?: SnappFoodProductDTO[] | null;
}

export interface SnappProductDto {
  menuItemId?: string | null;
  active?: boolean;
  /** @format int64 */
  vmsFoodId?: number | null;
  /** @format date-time */
  disabledUntil?: string | null;
  isDisable?: boolean;
  code?: string | null;
}

export interface SnappProductDtoResponseMessage {
  data?: SnappProductDto;
  status?: string | null;
}

export interface SyncMenuDto {
  vendorId?: string | null;
}

export interface UpdateAvailabilityCommand {
  menuItemId?: string | null;
}

export interface UpdateAvailableCommand {
  id?: string | null;
}

export interface UpdateBrandsCommand {
  vendorId?: string | null;
  /** @format int32 */
  snappFoodVendorId?: number | null;
  snappClientId?: string | null;
  snappClientSecret?: string | null;
  snappUserName?: string | null;
  snappPassword?: string | null;
  ropoloName?: string | null;
  vendorCode?: string | null;
}

export interface UpdateCategoryCommand {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  order?: number;
  isSnappSide?: boolean;
  /** @format int32 */
  printOrder?: number;
  code?: string | null;
}

export interface UpdateMenuItemCommand {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  /** @format int32 */
  price?: number;
  /** @format int32 */
  discount?: number;
  active?: boolean;
  /** @format int32 */
  order?: number;
  /** @format int32 */
  minCount?: number;
  /** @format int32 */
  maxCount?: number;
  available?: boolean;
  images?: string[] | null;
  /** @format int32 */
  packagingCost?: number;
  /** @format int32 */
  servePackagingCost?: number;
  categoryIds?: string[] | null;
  shiftIds?: string[] | null;
  tagsId?: string[] | null;
  sellChannels?: string[] | null;
  isSnappSide?: boolean;
  thirdPartyCode?: string | null;
  withTax?: boolean;
  code?: string | null;
}

export interface UpdateMenuItemStatusCommand {
  products?: ProductStatusDto[] | null;
}

export interface UpdatePrinterCommand {
  /** @format uuid */
  id?: string;
  name?: string | null;
  ip?: string | null;
}

export interface UpdatePrinterStationCommand {
  id?: string | null;
  /** @format uuid */
  printerId?: string;
  name?: string | null;
  menuCategoryIds?: string[] | null;
  menuItemIds?: string[] | null;
  layoutType?: PrintLayout;
  printOnSubmit?: boolean;
  printOnBikerAssignment?: boolean;
  hasAllItems?: boolean;
}

export interface UpdatePrinterStationResponse {
  id?: string | null;
  printerId?: string | null;
  name?: string | null;
  printLayout?: PrintLayout;
  printOnSubmit?: boolean;
  printOnBikerAssignment?: boolean;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
  softDelete?: boolean;
}

export interface UpdatePrinterStationResponseResponseMessage {
  data?: UpdatePrinterStationResponse;
  status?: string | null;
}

export interface UpdateToppingCategoryCommand {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  min?: number;
  /** @format int32 */
  max?: number;
  menuItemIds?: string[] | null;
}

export interface UpdateToppingCommand {
  id?: string | null;
  title?: string | null;
  /** @format int32 */
  price?: number;
  isActive?: boolean;
  available?: boolean;
  thirdPartyCode?: string | null;
}

export interface AddressIsInZoneDto {
  id?: string | null;
  title?: string | null;
  details?: string | null;
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
  isInZone?: boolean;
}

export interface AddressIsInZoneDtoListResponseMessage {
  data?: AddressIsInZoneDto[] | null;
  status?: string | null;
}

export interface ApiErrorResponseMessage {
  data?: ApiError;
  status?: string | null;
}

export interface DeliveryZoneDto {
  id?: string | null;
  polygonId?: string | null;
  vendorsProperName?: string | null;
  /** @format double */
  price?: number;
  currency?: Currency;
  enabled?: boolean;
}

export interface DeliveryZoneDtoListResponseMessage {
  data?: DeliveryZoneDto[] | null;
  status?: string | null;
}

export interface DeliveryZoneDtoResponseMessage {
  data?: DeliveryZoneDto;
  status?: string | null;
}

export interface DeliveryZoneEnableOrDisableRequest {
  enabled?: boolean | null;
}

export interface FeatureDto {
  type?: string | null;
  properties?: FeaturePropertiesDto;
  geometry?: FeatureGeometryDto;
}

export interface FeatureDtoListResponseMessage {
  data?: FeatureDto[] | null;
  status?: string | null;
}

export interface FeatureGeometryDto {
  type?: string | null;
  coordinates?: number[][][] | null;
}

export interface FeaturePropertiesDto {
  description?: string | null;
  name?: string | null;
}

export interface GetDeliveryPriceByAddressResponse {
  /** @format double */
  price?: number;
}

export interface GetDeliveryPriceByAddressResponseResponseMessage {
  data?: GetDeliveryPriceByAddressResponse;
  status?: string | null;
}

export interface GetProviderEstimatedPriceResponse {
  provider?: DeliveryProviderName;
  /** @format double */
  estimatedPrice?: number | null;
  errorMessage?: string | null;
}

export interface GetProviderEstimatedPriceResponseResponseMessage {
  data?: GetProviderEstimatedPriceResponse;
  status?: string | null;
}

export interface MiareCourier {
  image?: string | null;
  location?: MiareLocation;
  name?: string | null;
  phone_number?: string | null;
}

export interface MiareLocation {
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface MiareTrip {
  id?: string | null;
  is_round_trip?: boolean | null;
  /** @format double */
  delivery_cost?: number | null;
  courier?: MiareCourier;
}

export interface MiareWebHookBodyRequest {
  event?: string | null;
  trip?: MiareTrip;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface RegisterDeliveryByExpressPlusProviderRequest {
  customerId?: string | null;
  orderId?: string | null;
  provider?: DeliveryProviderName;
}

export interface RegisterDeliveryByProviderRequest {
  customerId?: string | null;
  orderId?: string | null;
  provider?: DeliveryProviderName;
}

export interface SendRadiusSupportByProviderLocation {
  /** @format double */
  latitude?: number;
  /** @format double */
  longitude?: number;
}

export interface SendRadiusSupportByProviderResponse {
  source?: SendRadiusSupportByProviderLocation;
  destination?: SendRadiusSupportByProviderLocation;
  deliveryProvider?: DeliveryProviderName;
  /** @format double */
  destinationDistance?: number | null;
  /** @format double */
  supportedSendingRadiusDistance?: number | null;
  isSupported?: boolean | null;
}

export interface SendRadiusSupportByProviderResponseResponseMessage {
  data?: SendRadiusSupportByProviderResponse;
  status?: string | null;
}

export interface SnappBoxWebHookRequestBody {
  webhookType?: string | null;
  orderId?: string | null;
  orderStatus?: string | null;
  bikerName?: string | null;
  bikerPhone?: string | null;
  orderAcceptedAt?: string | null;
  bikerPhotoUrl?: string | null;
  customerRefId?: string | null;
  sequenceNumber?: string | null;
  /** @format float */
  latitude?: number | null;
  /** @format float */
  longitude?: number | null;
}

export interface UpsertDeliveryZoneRequest {
  vendorsProperName?: string | null;
  /** @format double */
  price?: number | null;
  enabled?: boolean | null;
}

import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, HeadersDefaults, ResponseType } from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({ securityWorker, secure, format, ...axiosConfig }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method && this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { 'Content-Type': type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Identity service
 * @version v1
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  apiIdentity = {
    /**
     * No description
     *
     * @tags UserSubscriptionCode
     * @name ApiUsersubscriptioncodeCreate
     * @request POST:/api-identity/api/usersubscriptioncode
     * @secure
     */
    apiUsersubscriptioncodeCreate: (data: AddUserSubscriptionCodeCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/api/usersubscriptioncode`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSubscriptionCode
     * @name ApiUsersubscriptioncodeUpdate
     * @request PUT:/api-identity/api/usersubscriptioncode
     * @secure
     */
    apiUsersubscriptioncodeUpdate: (data: UpdateUserSubscriptionCodeCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/api/usersubscriptioncode`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSubscriptionCode
     * @name ApiUsersubscriptioncodeDelete
     * @request DELETE:/api-identity/api/usersubscriptioncode
     * @secure
     */
    apiUsersubscriptioncodeDelete: (data: DeleteUserSubscriptionCodeCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/api/usersubscriptioncode`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSubscriptionCode
     * @name ApiUsersubscriptioncodeDetail
     * @request GET:/api-identity/api/usersubscriptioncode/{userId}
     * @secure
     */
    apiUsersubscriptioncodeDetail: (userId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/api/usersubscriptioncode/${userId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags UserSubscriptionCode
     * @name ApiUsersubscriptioncodeGetusersubscriptioncodesList
     * @request GET:/api-identity/api/usersubscriptioncode/getusersubscriptioncodes
     * @secure
     */
    apiUsersubscriptioncodeGetusersubscriptioncodesList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/api/usersubscriptioncode/getusersubscriptioncodes`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressList
     * @request GET:/api-identity/identity/address
     * @secure
     */
    identityAddressList: (params: RequestParams = {}) =>
      this.request<AddressQueryResponseListResponseMessage, ApiError>({
        path: `/api-identity/identity/address`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressCreate
     * @request POST:/api-identity/identity/address
     * @secure
     */
    identityAddressCreate: (data: CreateAddressCommand, params: RequestParams = {}) =>
      this.request<CreateAddressResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/address`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressUpdate
     * @request PUT:/api-identity/identity/address
     * @secure
     */
    identityAddressUpdate: (data: UpdateAddressCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/address`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressDetail
     * @request GET:/api-identity/identity/address/{id}
     * @secure
     */
    identityAddressDetail: (id: string, params: RequestParams = {}) =>
      this.request<AddressQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/address/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressDelete
     * @request DELETE:/api-identity/identity/address/{id}
     * @secure
     */
    identityAddressDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/address/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressOfflineCreate
     * @request POST:/api-identity/identity/address/offline
     * @secure
     */
    identityAddressOfflineCreate: (data: CreateOfflineAddressCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/address/offline`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressOfflineUpdate
     * @request PUT:/api-identity/identity/address/offline
     * @secure
     */
    identityAddressOfflineUpdate: (data: UpdateOfflineAddressCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/address/offline`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressOfflineDetail
     * @request GET:/api-identity/identity/address/offline/{userId}
     * @secure
     */
    identityAddressOfflineDetail: (userId: string, params: RequestParams = {}) =>
      this.request<AddressQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/address/offline/${userId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Address
     * @name IdentityAddressOfflineLatLongUpdate
     * @request PUT:/api-identity/identity/address/offline/lat-long
     * @secure
     */
    identityAddressOfflineLatLongUpdate: (data: UpdateLatLongOfflineAddressCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/address/offline/lat-long`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthAdminloginCreate
     * @request POST:/api-identity/identity/auth/adminlogin
     * @secure
     */
    identityAuthAdminloginCreate: (data: AdminLoginCommand, params: RequestParams = {}) =>
      this.request<VerifyOtpResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/auth/adminlogin`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthLoginCreate
     * @request POST:/api-identity/identity/auth/login
     * @secure
     */
    identityAuthLoginCreate: (data: LoginCommand, params: RequestParams = {}) =>
      this.request<LoginResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/auth/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthLogoutDelete
     * @request DELETE:/api-identity/identity/auth/logout
     * @secure
     */
    identityAuthLogoutDelete: (params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/auth/logout`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthMeUpdate
     * @request PUT:/api-identity/identity/auth/me
     * @secure
     */
    identityAuthMeUpdate: (data: UpdateProfileCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/auth/me`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthMeList
     * @request GET:/api-identity/identity/auth/me
     * @secure
     */
    identityAuthMeList: (params: RequestParams = {}) =>
      this.request<ProfileQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/auth/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthRefreshtokenCreate
     * @request POST:/api-identity/identity/auth/refreshtoken
     * @secure
     */
    identityAuthRefreshtokenCreate: (data: RefreshTokenCommand, params: RequestParams = {}) =>
      this.request<CreatedRefreshTokenEventResponseMessage, ApiError>({
        path: `/api-identity/identity/auth/refreshtoken`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name IdentityAuthVerifyCreate
     * @request POST:/api-identity/identity/auth/verify
     * @secure
     */
    identityAuthVerifyCreate: (data: VerifyOtpCommand, params: RequestParams = {}) =>
      this.request<VerifyOtpResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/auth/verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AvailabilityTime
     * @name IdentityAvailabilitytimeList
     * @request GET:/api-identity/identity/availabilitytime
     * @secure
     */
    identityAvailabilitytimeList: (params: RequestParams = {}) =>
      this.request<VendorAvailabilityTimeQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/availabilitytime`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AvailableSegments
     * @name IdentityAvailablesegmentsList
     * @request GET:/api-identity/identity/availablesegments
     * @secure
     */
    identityAvailablesegmentsList: (params: RequestParams = {}) =>
      this.request<AvailableSegmentQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/availablesegments`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags AvailableSegments
     * @name IdentityAvailablesegmentsDiscountcodesMessageDetail
     * @request GET:/api-identity/identity/availablesegments/{id}/discountcodes/{discountCodeId}/message
     * @secure
     */
    identityAvailablesegmentsDiscountcodesMessageDetail: (
      id: string,
      discountCodeId: string,
      params: RequestParams = {}
    ) =>
      this.request<StringResponseMessage, any>({
        path: `/api-identity/identity/availablesegments/${id}/discountcodes/${discountCodeId}/message`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name IdentityBanksList
     * @request GET:/api-identity/identity/banks
     * @secure
     */
    identityBanksList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<BankQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/banks`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name IdentityBanksCreate
     * @request POST:/api-identity/identity/banks
     * @secure
     */
    identityBanksCreate: (data: CreateBankCommand, params: RequestParams = {}) =>
      this.request<BankCreatedEventResponseMessage, any>({
        path: `/api-identity/identity/banks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name IdentityBanksUpdate
     * @request PUT:/api-identity/identity/banks
     * @secure
     */
    identityBanksUpdate: (data: UpdateBankCommand, params: RequestParams = {}) =>
      this.request<BankCreatedEvent, any>({
        path: `/api-identity/identity/banks`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name IdentityBanksDetail
     * @request GET:/api-identity/identity/banks/{id}
     * @secure
     */
    identityBanksDetail: (id: number, params: RequestParams = {}) =>
      this.request<BankQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/banks/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Banks
     * @name IdentityBanksDelete
     * @request DELETE:/api-identity/identity/banks/{id}
     * @secure
     */
    identityBanksDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/banks/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name IdentityBikersDetail
     * @request GET:/api-identity/identity/bikers/{id}
     * @secure
     */
    identityBikersDetail: (id: string, params: RequestParams = {}) =>
      this.request<UserQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/bikers/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name IdentityBikersLoginCreate
     * @request POST:/api-identity/identity/bikers/login
     * @secure
     */
    identityBikersLoginCreate: (data: SendOtpForBikerCommand, params: RequestParams = {}) =>
      this.request<LoginResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/bikers/login`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name IdentityBikersVerifyCreate
     * @request POST:/api-identity/identity/bikers/verify
     * @secure
     */
    identityBikersVerifyCreate: (data: VerifyBikerOtpCommand, params: RequestParams = {}) =>
      this.request<VerifyOtpResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/bikers/verify`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name IdentityContractsPaymentDetail
     * @request GET:/api-identity/identity/contracts/{usageid}/payment
     * @secure
     */
    identityContractsPaymentDetail: (
      usageid: string,
      query?: {
        paymentServiceType?: PaymentServiceType;
        submitUrl?: string;
        userId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentResponseResponseMessage, any>({
        path: `/api-identity/identity/contracts/${usageid}/payment`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name IdentityContractsAvailableList
     * @request GET:/api-identity/identity/contracts/available
     * @secure
     */
    identityContractsAvailableList: (params: RequestParams = {}) =>
      this.request<AvailableContractResponseResponseMessage, any>({
        path: `/api-identity/identity/contracts/available`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name IdentityContractsTransactionDetail
     * @request GET:/api-identity/identity/contracts/transaction/{id}
     * @secure
     */
    identityContractsTransactionDetail: (id: string, params: RequestParams = {}) =>
      this.request<UsageTransactionQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/contracts/transaction/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Contracts
     * @name IdentityContractsTransactionVerifyList
     * @request GET:/api-identity/identity/contracts/transaction/verify
     * @secure
     */
    identityContractsTransactionVerifyList: (
      query?: {
        /** @format uuid */
        clientReferenceNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/contracts/transaction/verify`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersList
     * @request GET:/api-identity/identity/customers
     * @secure
     */
    identityCustomersList: (
      query?: {
        UserType?: UserType;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<UserListQueryResponsePaginatedListResponseMessage, ApiError>({
        path: `/api-identity/identity/customers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersCreate
     * @request POST:/api-identity/identity/customers
     * @secure
     */
    identityCustomersCreate: (data: CreateCustomerCommand, params: RequestParams = {}) =>
      this.request<CustomerCreatedEventResponseMessage, any>({
        path: `/api-identity/identity/customers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersAddressDetail
     * @request GET:/api-identity/identity/customers/{id}/address
     * @secure
     */
    identityCustomersAddressDetail: (id: string, params: RequestParams = {}) =>
      this.request<AddressQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/customers/${id}/address`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersInformationDetail
     * @request GET:/api-identity/identity/customers/{id}/information
     * @secure
     */
    identityCustomersInformationDetail: (id: string, params: RequestParams = {}) =>
      this.request<OrderInfoQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/customers/${id}/information`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersReportList
     * @request GET:/api-identity/identity/customers/report
     * @secure
     */
    identityCustomersReportList: (
      query?: {
        Sort?: string;
        IsAscending?: boolean;
        /** @format int64 */
        From?: number;
        /** @format int64 */
        To?: number;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomerReportListResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/customers/report`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersReportExcelList
     * @request GET:/api-identity/identity/customers/report/excel
     * @secure
     */
    identityCustomersReportExcelList: (
      query?: {
        Sort?: string;
        IsAscending?: boolean;
        /** @format int64 */
        From?: number;
        /** @format int64 */
        To?: number;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api-identity/identity/customers/report/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Customers
     * @name IdentityCustomersSearchList
     * @request GET:/api-identity/identity/customers/search
     * @secure
     */
    identityCustomersSearchList: (
      query?: {
        search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CustomerSearchQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/customers/search`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionList
     * @request GET:/api-identity/identity/defaultdescription
     * @secure
     */
    identityDefaultdescriptionList: (
      query?: {
        HostDomain?: string;
        IsActive?: boolean;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DefaultDescriptionQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/defaultdescription`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionCreate
     * @request POST:/api-identity/identity/defaultdescription
     * @secure
     */
    identityDefaultdescriptionCreate: (data: CreateDefaultDescriptionCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/defaultdescription`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionUpdate
     * @request PUT:/api-identity/identity/defaultdescription
     * @secure
     */
    identityDefaultdescriptionUpdate: (data: UpdateActivationDescriptionCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/defaultdescription`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionDetail
     * @request GET:/api-identity/identity/defaultdescription/{id}
     * @secure
     */
    identityDefaultdescriptionDetail: (id: number, params: RequestParams = {}) =>
      this.request<DefaultDescriptionQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/defaultdescription/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionDelete
     * @request DELETE:/api-identity/identity/defaultdescription/{id}
     * @secure
     */
    identityDefaultdescriptionDelete: (id: number, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/defaultdescription/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DefaultDescription
     * @name IdentityDefaultdescriptionListList
     * @request GET:/api-identity/identity/defaultdescription/list
     * @secure
     */
    identityDefaultdescriptionListList: (params: RequestParams = {}) =>
      this.request<DefaultDescriptionQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/defaultdescription/list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name IdentityDeliveryzonesList
     * @request GET:/api-identity/identity/deliveryzones
     * @secure
     */
    identityDeliveryzonesList: (params: RequestParams = {}) =>
      this.request<DeliveryZoneQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/deliveryzones`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name IdentityDeliveryzonesCreate
     * @request POST:/api-identity/identity/deliveryzones
     * @secure
     */
    identityDeliveryzonesCreate: (data: CreateDeliveryZoneCommand, params: RequestParams = {}) =>
      this.request<DeliveryZoneQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/deliveryzones`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name IdentityDeliveryzonesUpdate
     * @request PUT:/api-identity/identity/deliveryzones
     * @secure
     */
    identityDeliveryzonesUpdate: (data: UpdateDeliveryZoneCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/deliveryzones`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name IdentityDeliveryzonesDetail
     * @request GET:/api-identity/identity/deliveryzones/{id}
     * @secure
     */
    identityDeliveryzonesDetail: (id: string, params: RequestParams = {}) =>
      this.request<DeliveryZoneQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/deliveryzones/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name IdentityDeliveryzonesDelete
     * @request DELETE:/api-identity/identity/deliveryzones/{id}
     * @secure
     */
    identityDeliveryzonesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/deliveryzones/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesList
     * @request GET:/api-identity/identity/discountcodes
     * @secure
     */
    identityDiscountcodesList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiscountCodeQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/discountcodes`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesCreate
     * @request POST:/api-identity/identity/discountcodes
     * @secure
     */
    identityDiscountcodesCreate: (data: CreateDiscountCodeCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/discountcodes`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesUpdate
     * @request PUT:/api-identity/identity/discountcodes
     * @secure
     */
    identityDiscountcodesUpdate: (data: ChangeDiscountCodeActivityStatusCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/discountcodes`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesDetail
     * @request GET:/api-identity/identity/discountcodes/{id}
     * @secure
     */
    identityDiscountcodesDetail: (id: string, params: RequestParams = {}) =>
      this.request<DiscountCodeQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/discountcodes/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesDelete
     * @request DELETE:/api-identity/identity/discountcodes/{id}
     * @secure
     */
    identityDiscountcodesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/discountcodes/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesAdminUpdateUpdate
     * @request PUT:/api-identity/identity/discountcodes/admin/update
     * @secure
     */
    identityDiscountcodesAdminUpdateUpdate: (data: UpdateDiscountCodeCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/discountcodes/admin/update`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesAllList
     * @request GET:/api-identity/identity/discountcodes/all
     * @secure
     */
    identityDiscountcodesAllList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiscountCodeListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/discountcodes/all`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesAvailableList
     * @request GET:/api-identity/identity/discountcodes/available
     * @secure
     */
    identityDiscountcodesAvailableList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiscountCodeAvaliableQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/discountcodes/available`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesGetbycodeDetail
     * @request GET:/api-identity/identity/discountcodes/getbycode/{code}
     * @secure
     */
    identityDiscountcodesGetbycodeDetail: (
      code: string,
      query?: {
        customerId?: string;
        /** @default false */
        isReadOnly?: boolean;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiscountCodeQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/discountcodes/getbycode/${code}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiscountCodes
     * @name IdentityDiscountcodesSiteGetbycodeDetail
     * @request GET:/api-identity/identity/discountcodes/site/getbycode/{code}
     * @secure
     */
    identityDiscountcodesSiteGetbycodeDetail: (code: string, params: RequestParams = {}) =>
      this.request<SiteDiscountCodeQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/discountcodes/site/getbycode/${code}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature
     * @name IdentityFeatureList
     * @request GET:/api-identity/identity/feature
     * @secure
     */
    identityFeatureList: (params: RequestParams = {}) =>
      this.request<FeatureQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/feature`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature
     * @name IdentityFeaturePackageDetail
     * @request GET:/api-identity/identity/feature/{id}/package
     * @secure
     */
    identityFeaturePackageDetail: (id: string, params: RequestParams = {}) =>
      this.request<PackageQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/feature/${id}/package`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature
     * @name IdentityFeatureIdentityPackageDetail
     * @request GET:/api-identity/identity/feature/identity-package/{id}
     * @secure
     */
    identityFeatureIdentityPackageDetail: (id: string, params: RequestParams = {}) =>
      this.request<PackageQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/feature/identity-package/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature
     * @name IdentityFeaturePackagesList
     * @request GET:/api-identity/identity/feature/packages
     * @secure
     */
    identityFeaturePackagesList: (params: RequestParams = {}) =>
      this.request<PackageQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/feature/packages`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feature
     * @name IdentityFeaturePackagesPriceDetail
     * @request GET:/api-identity/identity/feature/packages/{packageId}/price
     * @secure
     */
    identityFeaturePackagesPriceDetail: (
      packageId: string,
      query?: {
        /** @format uuid */
        ContractId?: string;
        Demo?: boolean;
        Installation?: boolean;
        PropertyValue?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PackagePriceQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/feature/packages/${packageId}/price`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Feedbacks
     * @name IdentityFeedbacksCreate
     * @request POST:/api-identity/identity/feedbacks
     * @secure
     */
    identityFeedbacksCreate: (data: CreateFeedbackCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/feedbacks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Files
     * @name IdentityFilesCreate
     * @request POST:/api-identity/identity/files
     * @secure
     */
    identityFilesCreate: (
      data: {
        Files?: File[];
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/files`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name IdentityPermissionsList
     * @request GET:/api-identity/identity/permissions
     * @secure
     */
    identityPermissionsList: (params: RequestParams = {}) =>
      this.request<PermissionQueryResponseListResponseMessage, ApiError>({
        path: `/api-identity/identity/permissions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name IdentityPermissionsCreate
     * @request POST:/api-identity/identity/permissions
     * @secure
     */
    identityPermissionsCreate: (data: CreateRolePermissionCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/permissions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name IdentityPermissionsUpdate
     * @request PUT:/api-identity/identity/permissions
     * @secure
     */
    identityPermissionsUpdate: (data: UpdateRolePermissionCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/permissions`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name IdentityPermissionsMeList
     * @request GET:/api-identity/identity/permissions/me
     * @secure
     */
    identityPermissionsMeList: (params: RequestParams = {}) =>
      this.request<MyPermissionQueryResponseListResponseMessage, ApiError>({
        path: `/api-identity/identity/permissions/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Permissions
     * @name IdentityPermissionsUserpermissionsList
     * @request GET:/api-identity/identity/permissions/userpermissions
     * @secure
     */
    identityPermissionsUserpermissionsList: (params: RequestParams = {}) =>
      this.request<UserPermissionQueryResponse[], any>({
        path: `/api-identity/identity/permissions/userpermissions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalCreate
     * @request POST:/api-identity/identity/posterminal
     * @secure
     */
    identityPosterminalCreate: (data: CreatePosTerminalCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/posterminal`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalUpdate
     * @request PUT:/api-identity/identity/posterminal
     * @secure
     */
    identityPosterminalUpdate: (data: UpdatePosTerminalCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/posterminal`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalDelete
     * @request DELETE:/api-identity/identity/posterminal
     * @secure
     */
    identityPosterminalDelete: (data: DeletePosTerminalCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/posterminal`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalActivatePartialUpdate
     * @request PATCH:/api-identity/identity/posterminal/activate
     * @secure
     */
    identityPosterminalActivatePartialUpdate: (data: ActivatePosTerminalCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/posterminal/activate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalBankprovidersList
     * @request GET:/api-identity/identity/posterminal/bankproviders
     * @secure
     */
    identityPosterminalBankprovidersList: (params: RequestParams = {}) =>
      this.request<TerminalBanksProviderArrayResponseMessage, ApiError>({
        path: `/api-identity/identity/posterminal/bankproviders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalDeactivatePartialUpdate
     * @request PATCH:/api-identity/identity/posterminal/deactivate
     * @secure
     */
    identityPosterminalDeactivatePartialUpdate: (data: DeActivatePosTerminalCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/posterminal/deactivate`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalGetbyidList
     * @request GET:/api-identity/identity/posterminal/getbyid
     * @secure
     */
    identityPosterminalGetbyidList: (
      query?: {
        /** @format uuid */
        id?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<PosTerminalViewModelResponseMessage, ApiError>({
        path: `/api-identity/identity/posterminal/getbyid`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PosTerminal
     * @name IdentityPosterminalPosterminalsList
     * @request GET:/api-identity/identity/posterminal/posterminals
     * @secure
     */
    identityPosterminalPosterminalsList: (params: RequestParams = {}) =>
      this.request<PosTerminalViewModelListResponseMessage, ApiError>({
        path: `/api-identity/identity/posterminal/posterminals`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name IdentityRolesList
     * @request GET:/api-identity/identity/roles
     * @secure
     */
    identityRolesList: (
      query?: {
        vendorId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RoleQueryResponseListResponseMessage, ApiError>({
        path: `/api-identity/identity/roles`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name IdentityRolesDelete
     * @request DELETE:/api-identity/identity/roles/{Id}
     * @secure
     */
    identityRolesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/roles/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Roles
     * @name IdentityRolesDetail
     * @request GET:/api-identity/identity/roles/{roleId}
     * @secure
     */
    identityRolesDetail: (roleId: string, params: RequestParams = {}) =>
      this.request<RolePermissionQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/roles/${roleId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationCreate
     * @request POST:/api-identity/identity/segmentation
     * @secure
     */
    identitySegmentationCreate: (data: CreateSegmentationCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/segmentation`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationUpdate
     * @request PUT:/api-identity/identity/segmentation
     * @secure
     */
    identitySegmentationUpdate: (data: UpdateSegmentationCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/segmentation`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationDelete
     * @request DELETE:/api-identity/identity/segmentation
     * @secure
     */
    identitySegmentationDelete: (data: DeleteSegmentationCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/segmentation`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationList
     * @request GET:/api-identity/identity/segmentation
     * @secure
     */
    identitySegmentationList: (params: RequestParams = {}) =>
      this.request<SegmentationsListQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/segmentation`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationNotificationCreate
     * @request POST:/api-identity/identity/segmentation/notification
     * @secure
     */
    identitySegmentationNotificationCreate: (data: SendNotificationSegmentCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/segmentation/notification`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationReportList
     * @request GET:/api-identity/identity/segmentation/report
     * @secure
     */
    identitySegmentationReportList: (
      query?: {
        /** @format uuid */
        Id?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ReportSegmentationListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/segmentation/report`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Segmentation
     * @name IdentitySegmentationUsersList
     * @request GET:/api-identity/identity/segmentation/users
     * @secure
     */
    identitySegmentationUsersList: (
      query?: {
        /** @format uuid */
        Id?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<UserSegmentationListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/segmentation/users`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesList
     * @request GET:/api-identity/identity/smspackages
     * @secure
     */
    identitySmspackagesList: (params: RequestParams = {}) =>
      this.request<SmsPackageQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/smspackages`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesCreditList
     * @request GET:/api-identity/identity/smspackages/credit
     * @secure
     */
    identitySmspackagesCreditList: (params: RequestParams = {}) =>
      this.request<VendorSmsPackageCreditResponseResponseMessage, any>({
        path: `/api-identity/identity/smspackages/credit`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesTransactionsList
     * @request GET:/api-identity/identity/smspackages/transactions
     * @secure
     */
    identitySmspackagesTransactionsList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SmsPackageTransactionQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/smspackages/transactions`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesTransactionsCreate
     * @request POST:/api-identity/identity/smspackages/transactions
     * @secure
     */
    identitySmspackagesTransactionsCreate: (data: CreateSmsPackageTransactionCommand, params: RequestParams = {}) =>
      this.request<SmsPackageTransactionResponseResponseMessage, any>({
        path: `/api-identity/identity/smspackages/transactions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesTransactionsDetail
     * @request GET:/api-identity/identity/smspackages/transactions/{id}
     * @secure
     */
    identitySmspackagesTransactionsDetail: (id: string, params: RequestParams = {}) =>
      this.request<SmsPackageTransactionDetailsResponseResponseMessage, any>({
        path: `/api-identity/identity/smspackages/transactions/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags SmsPackages
     * @name IdentitySmspackagesTransactionsVerifyList
     * @request GET:/api-identity/identity/smspackages/transactions/verify
     * @secure
     */
    identitySmspackagesTransactionsVerifyList: (
      query?: {
        /** @format uuid */
        clientReferenceNumber?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/smspackages/transactions/verify`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name IdentitySubscriptionsCreate
     * @request POST:/api-identity/identity/subscriptions
     * @secure
     */
    identitySubscriptionsCreate: (data: CreateSubscriptionCommand, params: RequestParams = {}) =>
      this.request<SubscriptionCreatedEventResponseMessage, any>({
        path: `/api-identity/identity/subscriptions`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name IdentitySubscriptionsUsagesList
     * @request GET:/api-identity/identity/subscriptions/usages
     * @secure
     */
    identitySubscriptionsUsagesList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<UsageListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-identity/identity/subscriptions/usages`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Subscriptions
     * @name IdentitySubscriptionsUsagesStatusList
     * @request GET:/api-identity/identity/subscriptions/usages/status
     * @secure
     */
    identitySubscriptionsUsagesStatusList: (params: RequestParams = {}) =>
      this.request<UsageStatusQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/subscriptions/usages/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersRolesDetail
     * @request GET:/api-identity/identity/users/{userId}/roles
     * @secure
     */
    identityUsersRolesDetail: (userId: string, params: RequestParams = {}) =>
      this.request<RoleQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/users/${userId}/roles`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersAddstaffCreate
     * @request POST:/api-identity/identity/users/addstaff
     * @secure
     */
    identityUsersAddstaffCreate: (data: AddStaffCommand, params: RequestParams = {}) =>
      this.request<UserCreatedEventResponseMessage, ApiError>({
        path: `/api-identity/identity/users/addstaff`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersCalleridList
     * @request GET:/api-identity/identity/users/callerid
     * @secure
     */
    identityUsersCalleridList: (
      query?: {
        number?: string;
        subDomain?: string;
        lineNumber?: string;
        status?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/users/callerid`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersMapReverseList
     * @request GET:/api-identity/identity/users/map/reverse
     * @secure
     */
    identityUsersMapReverseList: (
      query?: {
        /** @format double */
        lat?: number;
        /** @format double */
        lon?: number;
        /** @format int32 */
        zoom?: number;
        display?: boolean;
        type?: string;
        language?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/users/map/reverse`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersRemovestaffDelete
     * @request DELETE:/api-identity/identity/users/removestaff
     * @secure
     */
    identityUsersRemovestaffDelete: (data: DeleteStaffCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/users/removestaff`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersUpdatestaffroleCreate
     * @request POST:/api-identity/identity/users/updatestaffrole
     * @secure
     */
    identityUsersUpdatestaffroleCreate: (data: UpdateUserStaffRoleCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/users/updatestaffrole`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Users
     * @name IdentityUsersUserrolesDetail
     * @request GET:/api-identity/identity/users/userroles/{userId}
     * @secure
     */
    identityUsersUserrolesDetail: (
      userId: string,
      query?: {
        vendorId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<RoleQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/users/userroles/${userId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsList
     * @request GET:/api-identity/identity/vendors
     * @secure
     */
    identityVendorsList: (
      query?: {
        hostDomain?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetVendorByDomainResponseResponseMessage, any>({
        path: `/api-identity/identity/vendors`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsActivateUpdate
     * @request PUT:/api-identity/identity/vendors/activate
     * @secure
     */
    identityVendorsActivateUpdate: (data: ActivateVendorCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/vendors/activate`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsAvailabilitytimeCreate
     * @request POST:/api-identity/identity/vendors/availabilitytime
     * @secure
     */
    identityVendorsAvailabilitytimeCreate: (data: CreateAvailabilityTimeCommand, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/vendors/availabilitytime`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsAvailabilitytimeList
     * @request GET:/api-identity/identity/vendors/availabilitytime
     * @secure
     */
    identityVendorsAvailabilitytimeList: (params: RequestParams = {}) =>
      this.request<VendorAvailabilityTimeQueryResponseResponseMessage, ApiError>({
        path: `/api-identity/identity/vendors/availabilitytime`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsAvailabilitytimeDelete
     * @request DELETE:/api-identity/identity/vendors/availabilitytime/{id}
     * @secure
     */
    identityVendorsAvailabilitytimeDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-identity/identity/vendors/availabilitytime/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsBankList
     * @request GET:/api-identity/identity/vendors/bank
     * @secure
     */
    identityVendorsBankList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<VendorBankQueryResponsePaginatedListResponseMessage, ApiError>({
        path: `/api-identity/identity/vendors/bank`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsBankCreate
     * @request POST:/api-identity/identity/vendors/bank
     * @secure
     */
    identityVendorsBankCreate: (data: CreateVendorBankCommand, params: RequestParams = {}) =>
      this.request<VendorBankCreatedEvent, ApiError>({
        path: `/api-identity/identity/vendors/bank`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsBankUpdate
     * @request PUT:/api-identity/identity/vendors/bank
     * @secure
     */
    identityVendorsBankUpdate: (data: ChangeVendorBankActivityStatusCommand, params: RequestParams = {}) =>
      this.request<VendorBankCreatedEvent, ApiError>({
        path: `/api-identity/identity/vendors/bank`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsGetvendorbrandsList
     * @request GET:/api-identity/identity/vendors/getvendorbrands
     * @secure
     */
    identityVendorsGetvendorbrandsList: (params: RequestParams = {}) =>
      this.request<VendorBrandQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/vendors/getvendorbrands`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsLandingList
     * @request GET:/api-identity/identity/vendors/landing
     * @secure
     */
    identityVendorsLandingList: (params: RequestParams = {}) =>
      this.request<LandingQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/vendors/landing`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsMeList
     * @request GET:/api-identity/identity/vendors/me
     * @secure
     */
    identityVendorsMeList: (params: RequestParams = {}) =>
      this.request<VendorQueryResponseResponseMessage, any>({
        path: `/api-identity/identity/vendors/me`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsMeUpdate
     * @request PUT:/api-identity/identity/vendors/me
     * @secure
     */
    identityVendorsMeUpdate: (data: UpdateMyInfoCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-identity/identity/vendors/me`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name IdentityVendorsSetprintitemsonfactoroptionUpdate
     * @request PUT:/api-identity/identity/vendors/setprintitemsonfactoroption
     * @secure
     */
    identityVendorsSetprintitemsonfactoroptionUpdate: (
      data: SetPrintItemsOnFactorOptionCommand,
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-identity/identity/vendors/setprintitemsonfactoroption`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Viewpoints
     * @name IdentityViewpointsList
     * @request GET:/api-identity/identity/viewpoints
     * @secure
     */
    identityViewpointsList: (params: RequestParams = {}) =>
      this.request<ViewpointListQueryResponseListResponseMessage, any>({
        path: `/api-identity/identity/viewpoints`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  api = {
    /**
     * No description
     *
     * @tags BankConfiguration
     * @name BankconfigurationList
     * @request GET:/api/bankconfiguration
     * @secure
     */
    bankconfigurationList: (params: RequestParams = {}) =>
      this.request<BankConfigurationQueryResponseResponseMessage, any>({
        path: `/api/bankconfiguration`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags BankConfiguration
     * @name BankconfigurationCreate
     * @request POST:/api/bankconfiguration
     * @secure
     */
    bankconfigurationCreate: (data: UpdateBankConfigurationCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/bankconfiguration`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersCreate
     * @request POST:/api/bikers
     * @secure
     */
    bikersCreate: (data: BatchAssignOrderToBikerCommand, params: RequestParams = {}) =>
      this.request<OrderQueryResponseListResponseMessage, any>({
        path: `/api/bikers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersPartialUpdate
     * @request PATCH:/api/bikers
     * @secure
     */
    bikersPartialUpdate: (data: ChangeDeliveryHistoriesToDeliveredCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/bikers`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersList
     * @request GET:/api/bikers
     * @secure
     */
    bikersList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<BikerQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/bikers`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersAllBikersList
     * @request GET:/api/bikers/all-bikers
     * @secure
     */
    bikersAllBikersList: (params: RequestParams = {}) =>
      this.request<AllBikerQueryResponseListResponseMessage, any>({
        path: `/api/bikers/all-bikers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersBikerreportList
     * @request GET:/api/bikers/bikerreport
     * @secure
     */
    bikersBikerreportList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        BikerId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AssignedOrderToBikersResponseResponseMessage, any>({
        path: `/api/bikers/bikerreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersFreeBikersList
     * @request GET:/api/bikers/free-bikers
     * @secure
     */
    bikersFreeBikersList: (params: RequestParams = {}) =>
      this.request<BikerQueryResponseListResponseMessage, any>({
        path: `/api/bikers/free-bikers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersKeyValueList
     * @request GET:/api/bikers/key-value
     * @secure
     */
    bikersKeyValueList: (params: RequestParams = {}) =>
      this.request<BikerQueryResponseListResponseMessage, any>({
        path: `/api/bikers/key-value`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersOrderpreviewDetail
     * @request GET:/api/bikers/orderpreview/{orderId}
     * @secure
     */
    bikersOrderpreviewDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<OrderPreviewForBikerViewModelResponseMessage, any>({
        path: `/api/bikers/orderpreview/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersOrdersList
     * @request GET:/api/bikers/orders
     * @secure
     */
    bikersOrdersList: (params: RequestParams = {}) =>
      this.request<BikersAssignedOrderQueryResponseListResponseMessage, any>({
        path: `/api/bikers/orders`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersPagingreportList
     * @request GET:/api/bikers/pagingreport
     * @secure
     */
    bikersPagingreportList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        BikerId?: string;
        orderType?: OrderType;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<BikerReportResposeResponseMessage, any>({
        path: `/api/bikers/pagingreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersPagingreportExcelList
     * @request GET:/api/bikers/pagingreport/excel
     * @secure
     */
    bikersPagingreportExcelList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        BikerId?: string;
        orderType?: OrderType;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/bikers/pagingreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Bikers
     * @name BikersStatePartialUpdate
     * @request PATCH:/api/bikers/state
     * @secure
     */
    bikersStatePartialUpdate: (data: ChangeDeliveryHistoryStateCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/bikers/state`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clubs
     * @name ClubsEarnpointDetail
     * @request GET:/api/clubs/earnpoint/{orderId}
     * @secure
     */
    clubsEarnpointDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<EarnPointEventResponseMessage, any>({
        path: `/api/clubs/earnpoint/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clubs
     * @name ClubsEarnpointPreviewDetail
     * @request GET:/api/clubs/earnpoint/preview/{orderId}
     * @secure
     */
    clubsEarnpointPreviewDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<EarnPointEventResponseMessage, any>({
        path: `/api/clubs/earnpoint/preview/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Clubs
     * @name ClubsPointList
     * @request GET:/api/clubs/point
     * @secure
     */
    clubsPointList: (params: RequestParams = {}) =>
      this.request<UserPointEventResponseMessage, any>({
        path: `/api/clubs/point`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryCanceltripCreate
     * @request POST:/api/delivery/canceltrip
     * @secure
     */
    deliveryCanceltripCreate: (data: CancelDeliveryCommand, params: RequestParams = {}) =>
      this.request<CancelTripEventResponseMessage, any>({
        path: `/api/delivery/canceltrip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryGetbordardeliveryfeeList
     * @request GET:/api/delivery/getbordardeliveryfee
     * @secure
     */
    deliveryGetbordardeliveryfeeList: (
      query?: {
        orderCode?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DeliveryFeeResponseResponseMessage, any>({
        path: `/api/delivery/getbordardeliveryfee`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Delivery
     * @name DeliveryRequestnewtripCreate
     * @request POST:/api/delivery/requestnewtrip
     * @secure
     */
    deliveryRequestnewtripCreate: (data: RequestNewTripCommand, params: RequestParams = {}) =>
      this.request<RequestTripEventResponseMessage, any>({
        path: `/api/delivery/requestnewtrip`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryHistories
     * @name DeliveryhistoriesDelete
     * @request DELETE:/api/deliveryhistories
     * @secure
     */
    deliveryhistoriesDelete: (data: DeleteDeliveryHistoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/deliveryhistories`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryHistories
     * @name DeliveryhistoriesBordarwebhooksCreate
     * @request POST:/api/deliveryhistories/bordarwebhooks
     * @secure
     */
    deliveryhistoriesBordarwebhooksCreate: (data: UpdateBordarDeliveryHistoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/deliveryhistories/bordarwebhooks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryHistories
     * @name DeliveryhistoriesMiarewebhooksCreate
     * @request POST:/api/deliveryhistories/miarewebhooks
     * @secure
     */
    deliveryhistoriesMiarewebhooksCreate: (data: UpdateDeliveryHistoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/deliveryhistories/miarewebhooks`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableList
     * @request GET:/api/diningtable
     * @secure
     */
    diningtableList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiningTableQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/diningtable`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableCreate
     * @request POST:/api/diningtable
     * @secure
     */
    diningtableCreate: (data: CreateDiningTableRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtable`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableUpdate
     * @request PUT:/api/diningtable
     * @secure
     */
    diningtableUpdate: (data: UpdateDiningTableRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtable`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableAlltablesList
     * @request GET:/api/diningtable/alltables
     * @secure
     */
    diningtableAlltablesList: (params: RequestParams = {}) =>
      this.request<DinnigTableListQueryResponeListResponseMessage, any>({
        path: `/api/diningtable/alltables`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableReservesList
     * @request GET:/api/diningtable/reserves
     * @secure
     */
    diningtableReservesList: (params: RequestParams = {}) =>
      this.request<DiningTableReserveQueryResponseListResponseMessage, any>({
        path: `/api/diningtable/reserves`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableReservesPartialUpdate
     * @request PATCH:/api/diningtable/reserves
     * @secure
     */
    diningtableReservesPartialUpdate: (data: FreeDiningTableCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtable/reserves`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableReservesFreeUpdate
     * @request PUT:/api/diningtable/reserves/free
     * @secure
     */
    diningtableReservesFreeUpdate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtable/reserves/free`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableTablesList
     * @request GET:/api/diningtable/tables
     * @secure
     */
    diningtableTablesList: (
      query?: {
        CategoryId?: string;
        IsActive?: boolean;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DinnigTableListQueryResponePaginatedListResponseMessage, any>({
        path: `/api/diningtable/tables`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableTablesPartialUpdate
     * @request PATCH:/api/diningtable/tables
     * @secure
     */
    diningtableTablesPartialUpdate: (data: ToggleActivationTableCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtable/tables`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTable
     * @name DiningtableTablesDetail
     * @request GET:/api/diningtable/tables/{id}
     * @secure
     */
    diningtableTablesDetail: (id: string, params: RequestParams = {}) =>
      this.request<DinnigTableListQueryResponeResponseMessage, any>({
        path: `/api/diningtable/tables/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTableCategories
     * @name DiningtablecategoriesCreate
     * @request POST:/api/diningtablecategories
     * @secure
     */
    diningtablecategoriesCreate: (data: CreateDiningTableCategoryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtablecategories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTableCategories
     * @name DiningtablecategoriesUpdate
     * @request PUT:/api/diningtablecategories
     * @secure
     */
    diningtablecategoriesUpdate: (data: UpdateDiningTableCategoryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtablecategories`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTableCategories
     * @name DiningtablecategoriesPartialUpdate
     * @request PATCH:/api/diningtablecategories
     * @secure
     */
    diningtablecategoriesPartialUpdate: (data: ActiveDiningTableCategoryRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/diningtablecategories`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTableCategories
     * @name DiningtablecategoriesList
     * @request GET:/api/diningtablecategories
     * @secure
     */
    diningtablecategoriesList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiningTableCategoryQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/diningtablecategories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DiningTableCategories
     * @name DiningtablecategoriesDetail
     * @request GET:/api/diningtablecategories/{id}
     * @secure
     */
    diningtablecategoriesDetail: (id: string, params: RequestParams = {}) =>
      this.request<DiningTableCategoryQueryResponseResponseMessage, any>({
        path: `/api/diningtablecategories/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersList
     * @request GET:/api/orders
     * @secure
     */
    ordersList: (
      query?: {
        OrderState?: OrderState;
        OrderType?: OrderType;
        PaymentMethod?: PaymentMethod;
        DeliveryType?: DeliveryType;
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        IsPrinted?: boolean;
        FullName?: string;
        /** @format int64 */
        FactorNumber?: number;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/orders`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersCreate
     * @request POST:/api/orders
     * @secure
     */
    ordersCreate: (data: CreateOrderRequest, params: RequestParams = {}) =>
      this.request<OrderCreatedResponseResponseMessage, any>({
        path: `/api/orders`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersPartialUpdate
     * @request PATCH:/api/orders
     * @secure
     */
    ordersPartialUpdate: (data: OrderPatchRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/orders`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersDetail
     * @request GET:/api/orders/{orderId}
     * @secure
     */
    ordersDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<OrderQueryResponseResponseMessage, any>({
        path: `/api/orders/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersTransactionsDetail
     * @request GET:/api/orders/{orderId}/transactions
     * @secure
     */
    ordersTransactionsDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<TransactionQueryResponseListResponseMessage, any>({
        path: `/api/orders/${orderId}/transactions`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersCallforreadyorderUpdate
     * @request PUT:/api/orders/callforreadyorder/{id}
     * @secure
     */
    ordersCallforreadyorderUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/orders/callforreadyorder/${id}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersChangetableUpdate
     * @request PUT:/api/orders/changetable
     * @secure
     */
    ordersChangetableUpdate: (data: ChangeOrderTableCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/orders/changetable`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersEditpostpaidUpdate
     * @request PUT:/api/orders/editpostpaid
     * @secure
     */
    ordersEditpostpaidUpdate: (data: EditPostPaidOrderCommand, params: RequestParams = {}) =>
      this.request<OrderUpdatedEventResponseMessage, any>({
        path: `/api/orders/editpostpaid`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersGetcreditordersreportList
     * @request GET:/api/orders/getcreditordersreport
     * @secure
     */
    ordersGetcreditordersreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<CreditPaymentMethodOrdersReportResponsePaginatedListResponseMessage, any>({
        path: `/api/orders/getcreditordersreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersKioskCreate
     * @request POST:/api/orders/kiosk
     * @secure
     */
    ordersKioskCreate: (data: CreateKioskOrderRequest, params: RequestParams = {}) =>
      this.request<OrderCreatedResponseResponseMessage, any>({
        path: `/api/orders/kiosk`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersMeList
     * @request GET:/api/orders/me
     * @secure
     */
    ordersMeList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MyOrderListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/orders/me`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersPaymentDetail
     * @request GET:/api/orders/payment/{orderId}
     * @secure
     */
    ordersPaymentDetail: (
      orderId: string,
      query?: {
        submitUrl?: string;
        paymentServiceType?: PaymentServiceType;
        /** @format int32 */
        tip?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<PaymentResponseResponseMessage, any>({
        path: `/api/orders/payment/${orderId}`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersPostpaidCreate
     * @request POST:/api/orders/postpaid
     * @secure
     */
    ordersPostpaidCreate: (data: CreatePostPaidOrderCommand, params: RequestParams = {}) =>
      this.request<OrderQueryResponseResponseMessage, any>({
        path: `/api/orders/postpaid`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersQuickCreate
     * @request POST:/api/orders/quick
     * @secure
     */
    ordersQuickCreate: (data: CreateQuickOrderRequest, params: RequestParams = {}) =>
      this.request<OrderCreatedResponseResponseMessage, any>({
        path: `/api/orders/quick`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersRefundUpdate
     * @request PUT:/api/orders/refund
     * @secure
     */
    ordersRefundUpdate: (data: RefundOrderCommand, params: RequestParams = {}) =>
      this.request<OrderUpdatedEventResponseMessage, any>({
        path: `/api/orders/refund`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersStatePartialUpdate
     * @request PATCH:/api/orders/state
     * @secure
     */
    ordersStatePartialUpdate: (data: ChangeOrderStateCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/orders/state`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name OrdersUnAssignedToBikerList
     * @request GET:/api/orders/un-assigned-to-biker
     * @secure
     */
    ordersUnAssignedToBikerList: (params: RequestParams = {}) =>
      this.request<UnAssignedOrdersListQueryResponseListResponseMessage, any>({
        path: `/api/orders/un-assigned-to-biker`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsLinkCreate
     * @request POST:/api/payments/link
     * @secure
     */
    paymentsLinkCreate: (data: CreatePaymentLinkCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/payments/link`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsLinkDetail
     * @request GET:/api/payments/link/{id}
     * @secure
     */
    paymentsLinkDetail: (id: string, params: RequestParams = {}) =>
      this.request<OrderPaymentLinkResponseResponseMessage, any>({
        path: `/api/payments/link/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsManualpaybyposCreate
     * @request POST:/api/payments/manualpaybypos
     * @secure
     */
    paymentsManualpaybyposCreate: (data: ManualPaymentByPOSCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/payments/manualpaybypos`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Payments
     * @name PaymentsUserBalanceDetail
     * @request GET:/api/payments/user-balance/{amount}/{payType}
     * @secure
     */
    paymentsUserBalanceDetail: (amount: number, payType: SnappPayType, params: RequestParams = {}) =>
      this.request<UserBalanceEventResponseMessage, any>({
        path: `/api/payments/user-balance/${amount}/${payType}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuestionPool
     * @name QuestionpoolList
     * @request GET:/api/questionpool
     * @secure
     */
    questionpoolList: (params: RequestParams = {}) =>
      this.request<QuestionPoolQueryResponseListResponseMessage, any>({
        path: `/api/questionpool`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsCancelledorderExcelList
     * @request GET:/api/reports/cancelledorder/excel
     * @secure
     */
    reportsCancelledorderExcelList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/cancelledorder/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsCancelledorderstatisticsList
     * @request GET:/api/reports/cancelledorderstatistics
     * @secure
     */
    reportsCancelledorderstatisticsList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<CancelOrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/cancelledorderstatistics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsCancelledorderstatisticsperhourList
     * @request GET:/api/reports/cancelledorderstatisticsperhour
     * @secure
     */
    reportsCancelledorderstatisticsperhourList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<CancelOrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/cancelledorderstatisticsperhour`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsDashboardList
     * @request GET:/api/reports/dashboard
     * @secure
     */
    reportsDashboardList: (
      data: string[],
      query?: {
        periodTime?: PeriodTime;
      },
      params: RequestParams = {}
    ) =>
      this.request<DashboardReportQueryResponseResponseMessage, any>({
        path: `/api/reports/dashboard`,
        method: 'GET',
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetdiningtableordersdetailreportList
     * @request GET:/api/reports/getdiningtableordersdetailreport
     * @secure
     */
    reportsGetdiningtableordersdetailreportList: (
      query?: {
        /** @format int64 */
        DiningTableCategoryId?: number;
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<DiningTablesOrdersDetailReportResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/getdiningtableordersdetailreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetdiningtableordersreportList
     * @request GET:/api/reports/getdiningtableordersreport
     * @secure
     */
    reportsGetdiningtableordersreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<DiningTablesOrdersReportResponseListResponseMessage, any>({
        path: `/api/reports/getdiningtableordersreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetorderitemsdeliveryreportExcelList
     * @request GET:/api/reports/getorderitemsdeliveryreport/excel
     * @secure
     */
    reportsGetorderitemsdeliveryreportExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/getorderitemsdeliveryreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetorderitemsprinterstationsalesreportList
     * @request GET:/api/reports/getorderitemsprinterstationsalesreport
     * @secure
     */
    reportsGetorderitemsprinterstationsalesreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderItemsPrinterStationSalesReportResponseListResponseMessage, any>({
        path: `/api/reports/getorderitemsprinterstationsalesreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetorderitemsprinterstationsalesreportExcelList
     * @request GET:/api/reports/getorderitemsprinterstationsalesreport/excel
     * @secure
     */
    reportsGetorderitemsprinterstationsalesreportExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/getorderitemsprinterstationsalesreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetorderitemssalesreportList
     * @request GET:/api/reports/getorderitemssalesreport
     * @secure
     */
    reportsGetorderitemssalesreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderItemsSalesReportResponseListResponseMessage, any>({
        path: `/api/reports/getorderitemssalesreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetorderitemssalesreportExcelList
     * @request GET:/api/reports/getorderitemssalesreport/excel
     * @secure
     */
    reportsGetorderitemssalesreportExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/getorderitemssalesreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetstaffordersdetailreportList
     * @request GET:/api/reports/getstaffordersdetailreport
     * @secure
     */
    reportsGetstaffordersdetailreportList: (
      query?: {
        UserId?: string;
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<StaffOrdersDetailPaginatedListResponseMessage, any>({
        path: `/api/reports/getstaffordersdetailreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsGetstaffordersreportList
     * @request GET:/api/reports/getstaffordersreport
     * @secure
     */
    reportsGetstaffordersreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<StaffOrdersReportReponseListResponseMessage, any>({
        path: `/api/reports/getstaffordersreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsailedList
     * @request GET:/api/reports/mostsailed
     * @secure
     */
    reportsMostsailedList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/mostsailed`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsailedExcelList
     * @request GET:/api/reports/mostsailed/excel
     * @secure
     */
    reportsMostsailedExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        Search?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/mostsailed/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsaileditemtoppingList
     * @request GET:/api/reports/mostsaileditemtopping
     * @secure
     */
    reportsMostsaileditemtoppingList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/mostsaileditemtopping`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsaileditemtoppingperhourList
     * @request GET:/api/reports/mostsaileditemtoppingperhour
     * @secure
     */
    reportsMostsaileditemtoppingperhourList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/mostsaileditemtoppingperhour`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsailedperhourList
     * @request GET:/api/reports/mostsailedperhour
     * @secure
     */
    reportsMostsailedperhourList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/mostsailedperhour`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsailedperhourExcelList
     * @request GET:/api/reports/mostsailedperhour/excel
     * @secure
     */
    reportsMostsailedperhourExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        Search?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/mostsailedperhour/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsMostsailedreportList
     * @request GET:/api/reports/mostsailedreport
     * @secure
     */
    reportsMostsailedreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        Search?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponseListResponseMessage, any>({
        path: `/api/reports/mostsailedreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderExcelList
     * @request GET:/api/reports/order/excel
     * @secure
     */
    reportsOrderExcelList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/order/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderhistoryDetail
     * @request GET:/api/reports/orderhistory/{orderId}
     * @secure
     */
    reportsOrderhistoryDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<OrderHistoryQueryResponseListResponseMessage, any>({
        path: `/api/reports/orderhistory/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderpaidList
     * @request GET:/api/reports/orderpaid
     * @secure
     */
    reportsOrderpaidList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PaidReportQueryResponseResponseMessage, any>({
        path: `/api/reports/orderpaid`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsList
     * @request GET:/api/reports/orderstatistics
     * @secure
     */
    reportsOrderstatisticsList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/orderstatistics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsExcelList
     * @request GET:/api/reports/orderstatistics/excel
     * @secure
     */
    reportsOrderstatisticsExcelList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        PaymentMethod?: PaymentMethod;
        DeliveryType?: DeliveryType;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/orderstatistics/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsSeparationDayList
     * @request GET:/api/reports/orderstatistics/separation/day
     * @secure
     */
    reportsOrderstatisticsSeparationDayList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderReportSeparationPerDayQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/orderstatistics/separation/day`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsTypeList
     * @request GET:/api/reports/orderstatistics/type
     * @secure
     */
    reportsOrderstatisticsTypeList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        PaymentMethod?: PaymentMethod;
        DeliveryType?: DeliveryType;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderReportPerOrderTypeQueryResponseResponseMessage, any>({
        path: `/api/reports/orderstatistics/type`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsUserList
     * @request GET:/api/reports/orderstatistics/user
     * @secure
     */
    reportsOrderstatisticsUserList: (
      query?: {
        UserId?: string;
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderReportPerUserQueryResponseListResponseMessage, any>({
        path: `/api/reports/orderstatistics/user`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrderstatisticsperhourList
     * @request GET:/api/reports/orderstatisticsperhour
     * @secure
     */
    reportsOrderstatisticsperhourList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/orderstatisticsperhour`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsOrdersunpaidList
     * @request GET:/api/reports/ordersunpaid
     * @secure
     */
    reportsOrdersunpaidList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<UnpaidReportQueryResponseResponseMessage, any>({
        path: `/api/reports/ordersunpaid`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsProductsreportList
     * @request GET:/api/reports/productsreport
     * @secure
     */
    reportsProductsreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        IsDescending?: boolean;
        OrderByField?: string;
        CategoryId?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MostSalesItemQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/reports/productsreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsProductsreportExcelList
     * @request GET:/api/reports/productsreport/excel
     * @secure
     */
    reportsProductsreportExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        IsDescending?: boolean;
        OrderByField?: string;
        CategoryId?: string;
        vendorIds?: string[];
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/reports/productsreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsRefundorderreportDetail
     * @request GET:/api/reports/refundorderreport/{orderId}
     * @secure
     */
    reportsRefundorderreportDetail: (orderId: string, params: RequestParams = {}) =>
      this.request<RefundOrderReportQueryResponseListResponseMessage, any>({
        path: `/api/reports/refundorderreport/${orderId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsSnappfoodorderstatisticsList
     * @request GET:/api/reports/snappfoodorderstatistics
     * @secure
     */
    reportsSnappfoodorderstatisticsList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SnappFoodOrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/snappfoodorderstatistics`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Reports
     * @name ReportsSnappfoodorderstatisticsperhourList
     * @request GET:/api/reports/snappfoodorderstatisticsperhour
     * @secure
     */
    reportsSnappfoodorderstatisticsperhourList: (
      query?: {
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        FromHour?: string;
        ToHour?: string;
        FromHourDate?: string;
        ToHourDate?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<SnappFoodOrderReportQueryResponseResponseMessage, any>({
        path: `/api/reports/snappfoodorderstatisticsperhour`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name SettlementsList
     * @request GET:/api/settlements
     * @secure
     */
    settlementsList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SettlementQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/settlements`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name SettlementsInfoList
     * @request GET:/api/settlements/info
     * @secure
     */
    settlementsInfoList: (
      query?: {
        SettlementId?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderSettlementQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/settlements/info`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name SettlementsInfoDetail
     * @request GET:/api/settlements/info/{id}
     * @secure
     */
    settlementsInfoDetail: (id: string, params: RequestParams = {}) =>
      this.request<SettlementQueryResponseResponseMessage, any>({
        path: `/api/settlements/info/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Settlements
     * @name SettlementsInfoExcelDetail
     * @request GET:/api/settlements/info/{id}/excel
     * @secure
     */
    settlementsInfoExcelDetail: (id: string, params: RequestParams = {}) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/settlements/info/${id}/excel`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyCreate
     * @request POST:/api/survey
     * @secure
     */
    surveyCreate: (data: CreateSurveyRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/survey`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyUpdate
     * @request PUT:/api/survey
     * @secure
     */
    surveyUpdate: (data: UpdateSurveyRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/survey`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyList
     * @request GET:/api/survey
     * @secure
     */
    surveyList: (params: RequestParams = {}) =>
      this.request<VendorSurveyQueryResponseListResponseMessage, any>({
        path: `/api/survey`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyDetail
     * @request GET:/api/survey/{id}
     * @secure
     */
    surveyDetail: (id: string, params: RequestParams = {}) =>
      this.request<SurveyQueryResponseResponseMessage, any>({
        path: `/api/survey/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Survey
     * @name SurveyResponseCreate
     * @request POST:/api/survey/response
     * @secure
     */
    surveyResponseCreate: (data: ResponseSurveyApiModel, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/survey/response`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ThirdPartyIntegrations
     * @name ThirdpartyintegrationsSanadpardazOrdersList
     * @request GET:/api/thirdpartyintegrations/sanadpardaz/orders
     * @secure
     */
    thirdpartyintegrationsSanadpardazOrdersList: (
      query?: {
        VendorId?: string;
        /** @format date-time */
        From?: string;
        /** @format date-time */
        To?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/thirdpartyintegrations/sanadpardaz/orders`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsApprovepospaymentCreate
     * @request POST:/api/transactions/approvepospayment
     * @secure
     */
    transactionsApprovepospaymentCreate: (data: ApprovePOSPaymentCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/transactions/approvepospayment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsInitialpospaymentCreate
     * @request POST:/api/transactions/initialpospayment
     * @secure
     */
    transactionsInitialpospaymentCreate: (data: InitialPOSPaymentCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/transactions/initialpospayment`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsMeList
     * @request GET:/api/transactions/me
     * @secure
     */
    transactionsMeList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<TransactionQueryResponsePaginatedListResponseMessage, any>({
        path: `/api/transactions/me`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsPostransactionreportList
     * @request GET:/api/transactions/postransactionreport
     * @secure
     */
    transactionsPostransactionreportList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        OrderType?: OrderType;
        Search?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<PosTransactionOrderQueryResponseResponseMessage, any>({
        path: `/api/transactions/postransactionreport`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsPostransactionreportExcelList
     * @request GET:/api/transactions/postransactionreport/excel
     * @secure
     */
    transactionsPostransactionreportExcelList: (
      query?: {
        /** @format date-time */
        FromDate?: string;
        /** @format date-time */
        ToDate?: string;
        OrderType?: OrderType;
        Search?: string;
        vendorIds?: string[];
      },
      params: RequestParams = {}
    ) =>
      this.request<ExcelResponseResponseMessage, any>({
        path: `/api/transactions/postransactionreport/excel`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsTransactionStatusPartialUpdate
     * @request PATCH:/api/transactions/transaction-status
     * @secure
     */
    transactionsTransactionStatusPartialUpdate: (data: UpdateStatusTransactionCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/transactions/transaction-status`,
        method: 'PATCH',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsVerifyList
     * @request GET:/api/transactions/verify
     * @secure
     */
    transactionsVerifyList: (
      query?: {
        clientReferenceNumber?: string;
        vendorId?: string;
        snappPayToken?: string;
        kioskToken?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/transactions/verify`,
        method: 'GET',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Transactions
     * @name TransactionsVerifyCreate
     * @request POST:/api/transactions/verify
     * @secure
     */
    transactionsVerifyCreate: (
      query?: {
        clientReferenceNumber?: string;
        vendorId?: string;
        snappPayToken?: string;
        kioskToken?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api/transactions/verify`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),
  };
  apiCatalog = {
    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsList
     * @request GET:/api-catalog/catalog/foodshifts
     * @secure
     */
    catalogFoodshiftsList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<FoodShiftQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-catalog/catalog/foodshifts`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsCreate
     * @request POST:/api-catalog/catalog/foodshifts
     * @secure
     */
    catalogFoodshiftsCreate: (data: CreateFoodShiftCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-catalog/catalog/foodshifts`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsUpdate
     * @request PUT:/api-catalog/catalog/foodshifts
     * @secure
     */
    catalogFoodshiftsUpdate: (data: UpdateFoodShiftCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-catalog/catalog/foodshifts`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsDetail
     * @request GET:/api-catalog/catalog/foodshifts/{id}
     * @secure
     */
    catalogFoodshiftsDetail: (id: string, params: RequestParams = {}) =>
      this.request<FoodShiftQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/foodshifts/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsDelete
     * @request DELETE:/api-catalog/catalog/foodshifts/{id}
     * @secure
     */
    catalogFoodshiftsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-catalog/catalog/foodshifts/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags FoodShifts
     * @name CatalogFoodshiftsListList
     * @request GET:/api-catalog/catalog/foodshifts/list
     * @secure
     */
    catalogFoodshiftsListList: (params: RequestParams = {}) =>
      this.request<FoodShiftQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/foodshifts/list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesList
     * @request GET:/api-catalog/catalog/menucategories
     * @secure
     */
    catalogMenucategoriesList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MenuCategoryQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesDetail
     * @request GET:/api-catalog/catalog/menucategories/{id}
     * @secure
     */
    catalogMenucategoriesDetail: (id: string, params: RequestParams = {}) =>
      this.request<MenuCategoryQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesAllList
     * @request GET:/api-catalog/catalog/menucategories/all
     * @secure
     */
    catalogMenucategoriesAllList: (params: RequestParams = {}) =>
      this.request<MenuCategoryFilterQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories/all`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesListList
     * @request GET:/api-catalog/catalog/menucategories/list
     * @secure
     */
    catalogMenucategoriesListList: (params: RequestParams = {}) =>
      this.request<MenuCategoryQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories/list`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesPrinterList
     * @request GET:/api-catalog/catalog/menucategories/printer
     * @secure
     */
    catalogMenucategoriesPrinterList: (params: RequestParams = {}) =>
      this.request<MenuCategoryToMenuItemSiteQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories/printer`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name CatalogMenucategoriesSiteList
     * @request GET:/api-catalog/catalog/menucategories/site
     * @secure
     */
    catalogMenucategoriesSiteList: (
      query?: {
        sellChannel?: SellChannel;
      },
      params: RequestParams = {}
    ) =>
      this.request<MenuCategoryToMenuItemSiteQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/menucategories/site`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name CatalogMenuitemsList
     * @request GET:/api-catalog/catalog/menuitems
     * @secure
     */
    catalogMenuitemsList: (
      query?: {
        Available?: boolean;
        Active?: boolean;
        IsSnappFood?: boolean;
        CategoryId?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<MenuItemListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-catalog/catalog/menuitems`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name CatalogMenuitemsDetail
     * @request GET:/api-catalog/catalog/menuitems/{id}
     * @secure
     */
    catalogMenuitemsDetail: (id: string, params: RequestParams = {}) =>
      this.request<MenuItemQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/menuitems/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItemTag
     * @name CatalogMenuitemtagList
     * @request GET:/api-catalog/catalog/menuitemtag
     * @secure
     */
    catalogMenuitemtagList: (params: RequestParams = {}) =>
      this.request<MenuItemTagListResponseMessage, any>({
        path: `/api-catalog/catalog/menuitemtag`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printers
     * @name CatalogPrintersList
     * @request GET:/api-catalog/catalog/printers
     * @secure
     */
    catalogPrintersList: (params: RequestParams = {}) =>
      this.request<PrinterQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/printers`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printers
     * @name CatalogPrintersDetail
     * @request GET:/api-catalog/catalog/printers/{id}
     * @secure
     */
    catalogPrintersDetail: (id: string, params: RequestParams = {}) =>
      this.request<PrinterQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/printers/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrinterStations
     * @name CatalogPrinterstationsList
     * @request GET:/api-catalog/catalog/printerstations
     * @secure
     */
    catalogPrinterstationsList: (params: RequestParams = {}) =>
      this.request<PrinterStationQueryResponseListResponseMessage, any>({
        path: `/api-catalog/catalog/printerstations`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrinterStations
     * @name CatalogPrinterstationsDetail
     * @request GET:/api-catalog/catalog/printerstations/{id}
     * @secure
     */
    catalogPrinterstationsDetail: (id: string, params: RequestParams = {}) =>
      this.request<PrinterStationQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/printerstations/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name CatalogToppingList
     * @request GET:/api-catalog/catalog/topping
     * @secure
     */
    catalogToppingList: (
      query?: {
        CategoryId?: string;
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ToppingListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-catalog/catalog/topping`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name CatalogToppingDetail
     * @request GET:/api-catalog/catalog/topping/{id}
     * @secure
     */
    catalogToppingDetail: (id: string, params: RequestParams = {}) =>
      this.request<ToppingQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/topping/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name CatalogToppingcategoryList
     * @request GET:/api-catalog/catalog/toppingcategory
     * @secure
     */
    catalogToppingcategoryList: (
      query?: {
        /** @format int32 */
        PageNumber?: number;
        /** @format int32 */
        PageSize?: number;
        Search?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<ToppingCategoryListQueryResponsePaginatedListResponseMessage, any>({
        path: `/api-catalog/catalog/toppingcategory`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name CatalogToppingcategoryDetail
     * @request GET:/api-catalog/catalog/toppingcategory/{id}
     * @secure
     */
    catalogToppingcategoryDetail: (id: string, params: RequestParams = {}) =>
      this.request<ToppingCategoryQueryResponseResponseMessage, any>({
        path: `/api-catalog/catalog/toppingcategory/${id}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  apiSnappFood = {
    /**
     * No description
     *
     * @tags Expresses
     * @name ApiExpressesFoodisreadyCreate
     * @request POST:/api-snappFood/api/expresses/foodisready/{code}
     * @secure
     */
    apiExpressesFoodisreadyCreate: (code: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/api/expresses/foodisready/${code}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Expresses
     * @name ApiExpressesTripdelayCreate
     * @request POST:/api-snappFood/api/expresses/tripdelay/{code}
     * @secure
     */
    apiExpressesTripdelayCreate: (code: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/api/expresses/tripdelay/${code}`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printers
     * @name ApiPrintersCreate
     * @request POST:/api-snappFood/api/printers
     * @secure
     */
    apiPrintersCreate: (data: CreatePrinterCommand, params: RequestParams = {}) =>
      this.request<CreatePrinterResponseResponseMessage, any>({
        path: `/api-snappFood/api/printers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printers
     * @name ApiPrintersUpdate
     * @request PUT:/api-snappFood/api/printers
     * @secure
     */
    apiPrintersUpdate: (data: UpdatePrinterCommand, params: RequestParams = {}) =>
      this.request<CreatePrinterResponseResponseMessage, any>({
        path: `/api-snappFood/api/printers`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Printers
     * @name ApiPrintersDelete
     * @request DELETE:/api-snappFood/api/printers/{Id}
     * @secure
     */
    apiPrintersDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/api/printers/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrinterStations
     * @name ApiPrinterstationsCreate
     * @request POST:/api-snappFood/api/printerstations
     * @secure
     */
    apiPrinterstationsCreate: (data: CreatePrinterStationCommand, params: RequestParams = {}) =>
      this.request<CreatePrinterStationResponseResponseMessage, any>({
        path: `/api-snappFood/api/printerstations`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrinterStations
     * @name ApiPrinterstationsUpdate
     * @request PUT:/api-snappFood/api/printerstations
     * @secure
     */
    apiPrinterstationsUpdate: (data: UpdatePrinterStationCommand, params: RequestParams = {}) =>
      this.request<UpdatePrinterStationResponseResponseMessage, any>({
        path: `/api-snappFood/api/printerstations`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags PrinterStations
     * @name ApiPrinterstationsDelete
     * @request DELETE:/api-snappFood/api/printerstations/{Id}
     * @secure
     */
    apiPrinterstationsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/api/printerstations/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesList
     * @request GET:/api-snappFood/snappfood/menucategories
     * @secure
     */
    snappfoodMenucategoriesList: (params: RequestParams = {}) =>
      this.request<CategoryWithMenuItemsDtoListResponseMessage, any>({
        path: `/api-snappFood/snappfood/menucategories`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesCreate
     * @request POST:/api-snappFood/snappfood/menucategories
     * @secure
     */
    snappfoodMenucategoriesCreate: (data: CreateCategoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menucategories`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesUpdate
     * @request PUT:/api-snappFood/snappfood/menucategories
     * @secure
     */
    snappfoodMenucategoriesUpdate: (data: UpdateCategoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menucategories`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesActivationUpdate
     * @request PUT:/api-snappFood/snappfood/menucategories/activation/{id}
     * @secure
     */
    snappfoodMenucategoriesActivationUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menucategories/activation/${id}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesSendtosnappfoodUpdate
     * @request PUT:/api-snappFood/snappfood/menucategories/sendtosnappfood/{id}
     * @secure
     */
    snappfoodMenucategoriesSendtosnappfoodUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menucategories/sendtosnappfood/${id}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuCategories
     * @name SnappfoodMenucategoriesSnappactivationUpdate
     * @request PUT:/api-snappFood/snappfood/menucategories/snappactivation/{id}
     * @secure
     */
    snappfoodMenucategoriesSnappactivationUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menucategories/snappactivation/${id}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsCreate
     * @request POST:/api-snappFood/snappfood/menuitems
     * @secure
     */
    snappfoodMenuitemsCreate: (data: CreateMenuItemCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsUpdate
     * @request PUT:/api-snappFood/snappfood/menuitems
     * @secure
     */
    snappfoodMenuitemsUpdate: (data: UpdateMenuItemCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsDelete
     * @request DELETE:/api-snappFood/snappfood/menuitems/{id}
     * @secure
     */
    snappfoodMenuitemsDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsSnappinfoDetail
     * @request GET:/api-snappFood/snappfood/menuitems/{menuItemId}/snappinfo
     * @secure
     */
    snappfoodMenuitemsSnappinfoDetail: (menuItemId: string, params: RequestParams = {}) =>
      this.request<SnappProductDtoResponseMessage, any>({
        path: `/api-snappFood/snappfood/menuitems/${menuItemId}/snappinfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsGetmenuDetail
     * @request GET:/api-snappFood/snappfood/menuitems/getmenu/{vendorId}
     * @secure
     */
    snappfoodMenuitemsGetmenuDetail: (vendorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/getmenu/${vendorId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsGetvendormenuDetail
     * @request GET:/api-snappFood/snappfood/menuitems/getvendormenu/{vendorId}
     * @secure
     */
    snappfoodMenuitemsGetvendormenuDetail: (vendorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/getvendormenu/${vendorId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsProductavailabilityUpdate
     * @request PUT:/api-snappFood/snappfood/menuitems/productavailability
     * @secure
     */
    snappfoodMenuitemsProductavailabilityUpdate: (data: UpdateAvailabilityCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/productavailability`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsProductstatusUpdate
     * @request PUT:/api-snappFood/snappfood/menuitems/productstatus
     * @secure
     */
    snappfoodMenuitemsProductstatusUpdate: (data: UpdateMenuItemStatusCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/productstatus`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsSyncimageDetail
     * @request GET:/api-snappFood/snappfood/menuitems/syncimage/{vendorId}
     * @secure
     */
    snappfoodMenuitemsSyncimageDetail: (vendorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/syncimage/${vendorId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsSyncmenuCreate
     * @request POST:/api-snappFood/snappfood/menuitems/syncmenu
     * @secure
     */
    snappfoodMenuitemsSyncmenuCreate: (data: SyncMenuDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/syncmenu`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MenuItems
     * @name SnappfoodMenuitemsSyncvendormenuCreate
     * @request POST:/api-snappFood/snappfood/menuitems/syncvendormenu
     * @secure
     */
    snappfoodMenuitemsSyncvendormenuCreate: (data: SyncMenuDto, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/menuitems/syncvendormenu`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersAcceptCreate
     * @request POST:/api-snappFood/snappfood/orders/accept
     * @secure
     */
    snappfoodOrdersAcceptCreate: (data: AcceptOrderCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/orders/accept`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersAckCreate
     * @request POST:/api-snappFood/snappfood/orders/ack
     * @secure
     */
    snappfoodOrdersAckCreate: (data: AckOrderCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/orders/ack`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersCouponsDetail
     * @request GET:/api-snappFood/snappfood/orders/coupons/{billNumber}
     * @secure
     */
    snappfoodOrdersCouponsDetail: (billNumber: string, params: RequestParams = {}) =>
      this.request<StringResponseMessage, any>({
        path: `/api-snappFood/snappfood/orders/coupons/${billNumber}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersPickCreate
     * @request POST:/api-snappFood/snappfood/orders/pick
     * @secure
     */
    snappfoodOrdersPickCreate: (data: PickOrderCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/orders/pick`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersRejectCreate
     * @request POST:/api-snappFood/snappfood/orders/reject
     * @secure
     */
    snappfoodOrdersRejectCreate: (data: NeedForCallOrderCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/orders/reject`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersRejectcausesList
     * @request GET:/api-snappFood/snappfood/orders/rejectcauses
     * @secure
     */
    snappfoodOrdersRejectcausesList: (params: RequestParams = {}) =>
      this.request<KeyValueListResponseMessage, any>({
        path: `/api-snappFood/snappfood/orders/rejectcauses`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Orders
     * @name SnappfoodOrdersTakeorderCreate
     * @request POST:/api-snappFood/snappfood/orders/takeorder
     * @secure
     */
    snappfoodOrdersTakeorderCreate: (
      data: {
        /** @format uuid */
        Id?: string;
        /** @format date-time */
        ReceiveTime?: string;
        Code?: string;
        UserCode?: string;
        FullName?: string;
        FirstName?: string;
        LastName?: string;
        UserAddressCode?: string;
        Phone?: string;
        CellPhone?: string;
        /** @format int32 */
        Price?: number;
        Comment?: string;
        StatusCode?: string;
        ExpeditionType?: string;
        DeliverAddress?: string;
        BikerStatus?: string;
        BikerName?: string;
        /** @format int32 */
        OrderDate?: number;
        /** @format double */
        Latitude?: number;
        /** @format double */
        Longitude?: number;
        /** @format int32 */
        DeliveryPrice?: number;
        /** @format int32 */
        PackingPrice?: number;
        /** @format int32 */
        DeliveryTime?: number;
        /** @format int32 */
        PreparationTime?: number;
        /** @format int32 */
        TaxCoeff?: number;
        /** @format int32 */
        Tax?: number;
        /** @format double */
        VAT?: number;
        DiscountType?: string;
        /** @format int32 */
        DiscountValue?: number;
        NewOrderDate?: string;
        /** @format int32 */
        'OrderCoupon.Id'?: number;
        'OrderCoupon.Title'?: string;
        'OrderCoupon.Descriptions'?: string;
        'OrderCoupon.ConditionCode'?: string;
        'OrderCoupon.RewardCode'?: string;
        'OrderCoupon.RewardApplied'?: boolean;
        'OrderCoupon.RewardParams.Item'?: string;
        /** @format int32 */
        'OrderCoupon.RewardParams.VmsFoodId'?: number;
        'OrderCoupon.RewardParams.Delivery_fee'?: string;
        /** @format double */
        'OrderCoupon.RewardParams.SF_share'?: number;
        /** @format double */
        'OrderCoupon.RewardParams.Total'?: number;
        /** @format int32 */
        'OrderCoupon.RewardParams.Max_discount_amount'?: number;
        OrderPaymentTypeCode?: string;
        /** @format int32 */
        VendorMaxPreparationTime?: number;
        VendorCode?: string;
        /** @format int32 */
        CouponDiscountVendorShareAmount?: number;
        /** @format int32 */
        CouponDiscountSfShareAmount?: number;
        Products?: SnappFoodProductDTO[];
        /** @format int32 */
        FactorNumber?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/orders/takeorder`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingCreate
     * @request POST:/api-snappFood/snappfood/topping
     * @secure
     */
    snappfoodToppingCreate: (data: CreateToppingCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingUpdate
     * @request PUT:/api-snappFood/snappfood/topping
     * @secure
     */
    snappfoodToppingUpdate: (data: UpdateToppingCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingDelete
     * @request DELETE:/api-snappFood/snappfood/topping/{id}
     * @secure
     */
    snappfoodToppingDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingActivationSnappfoodUpdate
     * @request PUT:/api-snappFood/snappfood/topping/activation-snappfood
     * @secure
     */
    snappfoodToppingActivationSnappfoodUpdate: (data: ActivationCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/activation-snappfood`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingDeletetoppingDelete
     * @request DELETE:/api-snappFood/snappfood/topping/deletetopping
     * @secure
     */
    snappfoodToppingDeletetoppingDelete: (data: DeleteVendorToppingCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/deletetopping`,
        method: 'DELETE',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingGettoppingDetail
     * @request GET:/api-snappFood/snappfood/topping/gettopping/{vendorId}
     * @secure
     */
    snappfoodToppingGettoppingDetail: (vendorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/gettopping/${vendorId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingSynctoppingCreate
     * @request POST:/api-snappFood/snappfood/topping/synctopping
     * @secure
     */
    snappfoodToppingSynctoppingCreate: (
      query?: {
        vendorId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/synctopping`,
        method: 'POST',
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Topping
     * @name SnappfoodToppingUpdateAvailableUpdate
     * @request PUT:/api-snappFood/snappfood/topping/update-available
     * @secure
     */
    snappfoodToppingUpdateAvailableUpdate: (data: UpdateAvailableCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/topping/update-available`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name SnappfoodToppingcategoryCreate
     * @request POST:/api-snappFood/snappfood/toppingcategory
     * @secure
     */
    snappfoodToppingcategoryCreate: (data: CreateToppingCategoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/toppingcategory`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name SnappfoodToppingcategoryUpdate
     * @request PUT:/api-snappFood/snappfood/toppingcategory
     * @secure
     */
    snappfoodToppingcategoryUpdate: (data: UpdateToppingCategoryCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/toppingcategory`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name SnappfoodToppingcategoryDelete
     * @request DELETE:/api-snappFood/snappfood/toppingcategory/{id}
     * @secure
     */
    snappfoodToppingcategoryDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/toppingcategory/${id}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ToppingCategory
     * @name SnappfoodToppingcategorySendToSnappFoodUpdate
     * @request PUT:/api-snappFood/snappfood/toppingcategory/{id}/send-to-snapp-food
     * @secure
     */
    snappfoodToppingcategorySendToSnappFoodUpdate: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/toppingcategory/${id}/send-to-snapp-food`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name SnappfoodVendorsDetail
     * @request GET:/api-snappFood/snappfood/vendors/{vendorId}
     * @secure
     */
    snappfoodVendorsDetail: (vendorId: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/vendors/${vendorId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name SnappfoodVendorsSnappfoodsettingCreate
     * @request POST:/api-snappFood/snappfood/vendors/snappfoodsetting
     * @secure
     */
    snappfoodVendorsSnappfoodsettingCreate: (data: CreateBrandsCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/vendors/snappfoodsetting`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Vendors
     * @name SnappfoodVendorsSnappfoodsettingUpdate
     * @request PUT:/api-snappFood/snappfood/vendors/snappfoodsetting
     * @secure
     */
    snappfoodVendorsSnappfoodsettingUpdate: (data: UpdateBrandsCommand, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-snappFood/snappfood/vendors/snappfoodsetting`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
  apiDelivery = {
    /**
     * No description
     *
     * @tags CustomerAddresses
     * @name V1CustomerAddressesBasedOnDeliveryZonesList
     * @request GET:/api-delivery/v1/customer-addresses/based-on-delivery-zones
     * @secure
     */
    v1CustomerAddressesBasedOnDeliveryZonesList: (
      query?: {
        VendorId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<AddressIsInZoneDtoListResponseMessage, any>({
        path: `/api-delivery/v1/customer-addresses/based-on-delivery-zones`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryByProviders
     * @name V1DeliveryByProvidersCreate
     * @request POST:/api-delivery/v1/delivery-by-providers
     * @secure
     */
    v1DeliveryByProvidersCreate: (data: RegisterDeliveryByProviderRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/delivery-by-providers`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryByProviders
     * @name V1DeliveryByProvidersDelete
     * @request DELETE:/api-delivery/v1/delivery-by-providers/{OrderId}
     * @secure
     */
    v1DeliveryByProvidersDelete: (orderId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/delivery-by-providers/${orderId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryByProviders
     * @name V1DeliveryByProvidersEstimatedPriceList
     * @request GET:/api-delivery/v1/delivery-by-providers/estimated-price
     * @secure
     */
    v1DeliveryByProvidersEstimatedPriceList: (
      query?: {
        Provider?: DeliveryProviderName;
        OrderId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetProviderEstimatedPriceResponseResponseMessage, ApiError>({
        path: `/api-delivery/v1/delivery-by-providers/estimated-price`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryByProviders
     * @name V1DeliveryByProvidersProviderDistanceSupportList
     * @request GET:/api-delivery/v1/delivery-by-providers/provider-distance-support
     * @secure
     */
    v1DeliveryByProvidersProviderDistanceSupportList: (
      query?: {
        Provider?: DeliveryProviderName;
        OrderId?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<SendRadiusSupportByProviderResponseResponseMessage, ApiError>({
        path: `/api-delivery/v1/delivery-by-providers/provider-distance-support`,
        method: 'GET',
        query: query,
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryPrices
     * @name V1DeliveryPricesAddressVendorDetail
     * @request GET:/api-delivery/v1/delivery-prices/address/{addressId}/vendor/{vendorId}
     * @secure
     */
    v1DeliveryPricesAddressVendorDetail: (addressId: string, vendorId: string, params: RequestParams = {}) =>
      this.request<GetDeliveryPriceByAddressResponseResponseMessage, ApiErrorResponseMessage>({
        path: `/api-delivery/v1/delivery-prices/address/${addressId}/vendor/${vendorId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name V1DeliveryZonesList
     * @request GET:/api-delivery/v1/delivery-zones
     * @secure
     */
    v1DeliveryZonesList: (params: RequestParams = {}) =>
      this.request<DeliveryZoneDtoListResponseMessage, ApiError>({
        path: `/api-delivery/v1/delivery-zones`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name V1DeliveryZonesDetail
     * @request GET:/api-delivery/v1/delivery-zones/{polygonId}
     * @secure
     */
    v1DeliveryZonesDetail: (polygonId: string, params: RequestParams = {}) =>
      this.request<DeliveryZoneDtoResponseMessage, ProblemDetails>({
        path: `/api-delivery/v1/delivery-zones/${polygonId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name V1DeliveryZonesUpdate
     * @request PUT:/api-delivery/v1/delivery-zones/{polygonId}
     * @secure
     */
    v1DeliveryZonesUpdate: (polygonId: string, data: UpsertDeliveryZoneRequest, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/delivery-zones/${polygonId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name V1DeliveryZonesDelete
     * @request DELETE:/api-delivery/v1/delivery-zones/{polygonId}
     * @secure
     */
    v1DeliveryZonesDelete: (polygonId: string, params: RequestParams = {}) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/delivery-zones/${polygonId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeliveryZones
     * @name V1DeliveryZonesEnableOrDisableUpdate
     * @request PUT:/api-delivery/v1/delivery-zones/{polygonId}/enable-or-disable
     * @secure
     */
    v1DeliveryZonesEnableOrDisableUpdate: (
      polygonId: string,
      data: DeliveryZoneEnableOrDisableRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/delivery-zones/${polygonId}/enable-or-disable`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ExpressPlusDelivery
     * @name V1ExpressPlusRequestDeliveryCreate
     * @request POST:/api-delivery/v1/express-plus/request-delivery
     * @secure
     */
    v1ExpressPlusRequestDeliveryCreate: (
      data: RegisterDeliveryByExpressPlusProviderRequest,
      params: RequestParams = {}
    ) =>
      this.request<void, ApiError>({
        path: `/api-delivery/v1/express-plus/request-delivery`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags MiareWebHooks
     * @name V1HooksMiareCreate
     * @request POST:/api-delivery/v1/hooks/miare
     * @secure
     */
    v1HooksMiareCreate: (data: MiareWebHookBodyRequest, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-delivery/v1/hooks/miare`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SnappBoxWebHooks
     * @name V1HooksSnappBoxCreate
     * @request POST:/api-delivery/v1/hooks/snapp-box
     * @secure
     */
    v1HooksSnappBoxCreate: (data: SnappBoxWebHookRequestBody, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api-delivery/v1/hooks/snapp-box`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Polygons
     * @name V1PolygonsList
     * @request GET:/api-delivery/v1/polygons
     * @secure
     */
    v1PolygonsList: (params: RequestParams = {}) =>
      this.request<FeatureDtoListResponseMessage, ApiError>({
        path: `/api-delivery/v1/polygons`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
